{
  "createHub": {
    "title": "Erstellen",
    "open": "Erstellen",
    "close": "Schließen",
    "actionsHeader": "Starten",
    "newWorkout": {
      "title": "Neues Workout",
      "sub": "Jetzt ein leeres Workout starten"
    },
    "repeatWorkout": {
      "title": "Workout wiederholen",
      "sub": "Aus einem früheren Workout erneut loggen"
    },
    "planProgram": {
      "title": "Programm planen",
      "sub": "Ein mehrwöchiges Trainingsprogramm erstellen"
    },
    "planWorkout": {
      "title": "Workout planen",
      "sub": "Eine einzelne Einheit für später vorbereiten"
    }
  },
  "library": {
    "header": "Stöbern",
    "tabPrograms": "Programme",
    "tabWorkouts": "Workouts",
    "tabPersonal": "Meine",
    "tabCoach": "Coach",
    "tabFavorites": "Favoriten",
    "favoriteA11y": "Favorit",
    "errFavorite": "Favoriten konnten nicht aktualisiert werden.",
    "emptyFavoritesTitle": "Noch keine Favoriten",
    "emptyFavoritesSub": "Markiere ein Programm oder Workout mit einem Stern, um es hier zu behalten.",
    "sectionOfficial": "Von JackedLogs",
    "sectionPersonal": "Meine",
    "clone": "Klonen",
    "copySuffix": "(Kopie)",
    "following": "Wird aktiviert…",
    "searchPlaceholder": "Nach Name suchen…",
    "filters": "Filter",
    "clearFilters": "Zurücksetzen",
    "axisLevel": "Niveau",
    "axisPerWeek": "Einheiten / Woche",
    "noResultsTitle": "Keine Treffer",
    "noResultsSub": "Passe Suche oder Filter an.",
    "loading": "Bibliothek wird geladen…",
    "errLoad": "Bibliothek konnte nicht geladen werden.",
    "errClone": "Klonen fehlgeschlagen. Versuch es erneut.",
    "errDelete": "Löschen fehlgeschlagen. Versuch es erneut.",
    "errFollow": "Programm konnte nicht gefolgt werden.",
    "errStatus": "Programm konnte nicht aktualisiert werden.",
    "emptyTitle": "Noch nichts hier",
    "emptySub": "Programme und Workouts, die du erstellst oder klonst, erscheinen hier.",
    "coachSoonTitle": "Vom Coach",
    "coachSoonSub": "Vom Coach zugewiesene Programme und Workouts erscheinen hier."
  },
  "common": {
    "lastDataAt": "Letzter Wert {{at}}",
    "languageA11y": "Sprache",
    "infoA11y": "Info",
    "unsavedChanges": {
      "title": "Änderungen verwerfen?",
      "body": "Die nicht gespeicherten Änderungen gehen verloren.",
      "keepEditing": "Weiter bearbeiten",
      "discard": "Verwerfen"
    }
  },
  "bodymap": {
    "viewBack": "Rücken",
    "viewFront": "Vorne",
    "workedTitle": "Belastete Muskeln",
    "workedPrimary": "primär",
    "workedSecondary": "sekundär",
    "heatmapTitle": "Meistbelastete Muskeln",
    "heatmapLow": "wenig",
    "heatmapHigh": "viel",
    "window7d": "7 Tage",
    "window30d": "30 Tage",
    "painTitle": "Schmerzkarte",
    "painHelp": "Tippe einen Muskel, um ihn zu markieren: rot (keine schweren Lasten), gelb (Vorsicht). Wird automatisch gespeichert.",
    "painRed": "meiden",
    "painYellow": "Vorsicht",
    "painClearAll": "Alles löschen",
    "painSaving": "Speichern…",
    "painSaveError": "Speichern fehlgeschlagen. Verbindung prüfen.",
    "painRiskA11y": "Schmerzrisiko: {{severity}}",
    "painSeverity": {
      "red": "hoch",
      "yellow": "mittel",
      "green": "gering"
    }
  },
  "plates": {
    "title": "Hantelscheiben",
    "openHint": "Scheibenverteilung anzeigen",
    "close": "Schließen",
    "targetLabel": "Ziel",
    "barLabel": "Stange",
    "barAria": "Stangengewicht",
    "barNone": "Ohne Stange",
    "perSide": "Pro Seite",
    "perSidePair": "{{count}} × {{plate}}",
    "barOnly": "Nur die Stange — keine Scheiben nötig.",
    "belowBar": "Das Ziel ist leichter als die Stange.",
    "invalidInput": "Erst ein gültiges Gewicht eingeben.",
    "remainder": "+{{weight}} unter dem Ziel mit dem aktuellen Bestand.",
    "fallbackPill": "höchstmöglich",
    "inventoryLegend": "Verfügbare Paare",
    "inventoryHint": "Paare jeder Scheibe, die gerade verfügbar sind. 0 setzen, wenn das Studio sie nicht hat oder das Rack leer ist. Sitzungsübergreifend gespeichert.",
    "pairsAria": "Paare {{plate}} verfügbar",
    "loadedEnd": "Belastetes Ende",
    "landmineHint": "Landmine: Nur das freie Ende ist belastet. Das andere Ende ist am Bodendrehpunkt verankert."
  },
  "app": {
    "title": "JackedLogs",
    "tagline": "Krafttraining, schlicht protokolliert.",
    "signedInAs": "Angemeldet als <bold>{{email}}</bold>.",
    "signOut": "Abmelden",
    "loading": "Lädt…",
    "checking": "wird geprüft…"
  },
  "auth": {
    "signIn": "Anmelden",
    "signInFailed": "Anmeldung fehlgeschlagen. Prüfe E-Mail und Passwort.",
    "createAccount": "Konto erstellen",
    "email": "E-Mail",
    "emailPlaceholder": "email@beispiel.com",
    "password": "Passwort",
    "passwordHint": "Mindestens 10 Zeichen mit Gross- und Kleinbuchstaben sowie einer Ziffer.",
    "switchToSignUp": "Noch kein Konto? Jetzt erstellen.",
    "switchToSignIn": "Schon ein Konto? Jetzt anmelden.",
    "submitting": "Wird verarbeitet…",
    "confirmTitle": "E-Mail bestätigen",
    "confirmHelp": "Wir haben einen Code an <bold>{{email}}</bold> gesendet. Fügen Sie ihn unten ein, um die Registrierung abzuschliessen.",
    "confirmCode": "Bestätigungscode",
    "confirmSubmit": "Bestätigen",
    "confirming": "Wird bestätigt…",
    "resendCode": "Code erneut senden",
    "resentInfo": "Code erneut gesendet. Prüfen Sie Ihren Posteingang.",
    "confirmedNowSignIn": "Konto bestätigt. Melden Sie sich an, um fortzufahren.",
    "forgotLink": "Passwort vergessen?",
    "forgotTitle": "Passwort zurücksetzen",
    "forgotIntro": "Geben Sie Ihre E-Mail-Adresse an. Wir senden Ihnen einen Code, um das Passwort zurückzusetzen.",
    "forgotSendCode": "Code senden",
    "forgotCodeSent": "Code gesendet. Bitte das Postfach prüfen.",
    "forgotConfirmHelp": "Code an <bold>{{email}}</bold> gesendet. Geben Sie ihn unten zusammen mit dem neuen Passwort ein.",
    "forgotResetSubmit": "Passwort zurücksetzen",
    "forgotResetDone": "Passwort aktualisiert. Bitte mit dem neuen Passwort anmelden.",
    "newPassword": "Neues Passwort",
    "backToSignIn": "Zurück zur Anmeldung"
  },
  "dashboard": {
    "meTitle": "Authentifizierter Round-Trip — /api/me",
    "healthTitle": "API-Status",
    "exportData": "Meine Daten exportieren",
    "deleteAccount": "Mein Konto löschen",
    "exporting": "Export wird vorbereitet…",
    "deleting": "Wird gelöscht…",
    "deleteConfirm": "Damit werden Ihr Konto und alle Ihre Daten dauerhaft gelöscht. Geben Sie LÖSCHEN zur Bestätigung ein.",
    "deleteCancel": "Abbrechen",
    "deletePlaceholder": "LÖSCHEN",
    "deleteSuccess": "Konto gelöscht.",
    "exportFilename": "jackedlogs-export-{{date}}.json",
    "privacyTitle": "Datenschutz",
    "privacyHelp": "Alle Daten als JSON exportieren oder das Konto vollständig löschen. Löschungen sind endgültig."
  },
  "privacy": {
    "linkLabel": "Datenschutz",
    "title": "Datenschutzerklärung",
    "lastUpdated": "Zuletzt aktualisiert: 20. August 2026 (Rechtsgrundlage)",
    "intro": "JackedLogs wird von einer einzelnen Person entwickelt und betrieben. Diese Erklärung beschreibt, was wir erheben, wo die Daten gespeichert sind und welche Rechte Sie haben.",
    "section1Title": "Was wir erheben",
    "section1Body": "Nur das, was für den Betrieb des Dienstes unbedingt erforderlich ist: Ihre E-Mail-Adresse (als Konto-Identifikator), ein gehashtes Passwort (verwaltet von Amazon Cognito — der Klartext verlässt nie Ihren Browser) und die Trainingsdaten, die Sie selbst erfassen. Wir erheben weder Name, Adresse, Telefonnummer noch Geburtsdatum oder einen Analyse-Fingerabdruck. Das Körpergewicht ist optional: wenn Sie es im Profil hinterlegen, kann die App die effektive Last bei Eigengewichtsübungen (Dip, Klimmzug usw.) berechnen. Es wird als besondere Gesundheitsdatenkategorie gemäss Art. 9 DSGVO und Art. 5 lit. c revDSG behandelt: niemals aggregiert, niemals geloggt, mit den übrigen Daten beim Kontolöschen entfernt.",
    "section2Title": "Wo die Daten liegen",
    "section2Body": "Alle Daten werden in der AWS-Region eu-central-2 (Zürich, Schweiz) gespeichert. Die Authentifizierung läuft auf Amazon Cognito; strukturierte Daten auf Amazon DynamoDB; statische Inhalte auf Amazon CloudFront. Wir verwenden keine Drittanbieter-Analyse-, Werbe- oder Tracking-Dienste.",
    "section3Title": "Ihre Rechte",
    "section3Body": "Sie können jederzeit Ihren gesamten Datensatz (JSON) exportieren oder Ihr Konto im Dashboard endgültig löschen. Die Löschung entfernt den Authentifizierungseintrag und jeden Datensatz, der Ihrem Konto zugeordnet ist — ohne Soft-Delete-Mechanismus.",
    "section4Title": "Kontakt",
    "section4Body": "Fragen oder Anfragen: {{email}}.",
    "section5Title": "Rechtsgrundlage",
    "section5Body": "Die Rechtsgrundlage der Verarbeitung ist gemäss schweizerischem revDSG und EU-DSGVO Ihre Einwilligung bei der Registrierung sowie das berechtigte Interesse an der Bereitstellung des angeforderten Dienstes. Vor jeder Erweiterung des Anwendungsbereichs aktualisieren wir diese Erklärung.",
    "back": "Zurück"
  },
  "errors": {
    "generic": "Etwas ist schiefgelaufen."
  },
  "feedback": {
    "title": "Feedback senden",
    "help": "Bug gefunden, Wunschfunktion, etwas anderes? Hier eintragen. Einreichungen erscheinen im Admin-Posteingang.",
    "kindLabel": "Art",
    "kind_bug": "Fehler",
    "kind_feature": "Funktionswunsch",
    "kind_other": "Sonstiges",
    "bodyLabel": "Was ist passiert?",
    "bodyPlaceholder": "Beschreibe, was du gesehen hast, was du erwartet hast und wie es reproduzierbar ist.",
    "send": "Senden",
    "sending": "Senden…",
    "sentFlash": "Danke — gesendet.",
    "sentHint": "Wir kümmern uns in der nächsten Session darum. Du kannst schliessen.",
    "close": "Schliessen",
    "errEmpty": "Bitte etwas eingeben, bevor du sendest.",
    "errSubmit": "Senden fehlgeschlagen. Bitte gleich erneut versuchen.",
    "errRateLimit": "Zu viele Einsendungen in der letzten Stunde. Bitte später erneut versuchen.",
    "inboxTitle": "Feedback-Posteingang",
    "loading": "Feedback wird geladen…",
    "empty": "Kein Feedback vorhanden.",
    "filterAll": "Alle",
    "loadMore": "Mehr laden",
    "status_open": "Offen",
    "status_in_progress": "In Bearbeitung",
    "status_shipped": "Behoben",
    "status_wontfix": "Nicht behoben",
    "priorityLabel": "Priorität",
    "priorityNone": "Keine",
    "statusLabel": "Status",
    "head_open": "{{count}} offen",
    "head_in_progress": "{{count}} in Bearbeitung",
    "head_shipped": "{{count}} behoben",
    "head_wontfix": "{{count}} nicht behoben",
    "headTotal": "{{count}} insgesamt"
  },
  "profile": {
    "title": "Profil",
    "loading": "Profil wird geladen…",
    "name": "Anzeigename",
    "namePlaceholder": "Wie sollen wir Sie ansprechen?",
    "role": "Rolle",
    "roleCoach": "Coach",
    "roleAthlete": "Athletin/Athlet",
    "roleBoth": "Beides",
    "ageBucket": "Altersgruppe (optional)",
    "ageBucketHelp": "Wird nur für freiwillige anonyme Gruppenstatistiken verwendet. Bleibt leer, wenn Sie nichts angeben.",
    "ageBucketNone": "Keine Angabe",
    "unitsPreference": "Bevorzugte Einheit",
    "unitsPreferenceHelp": "Gewichte werden immer in Kilogramm gespeichert. Pro Trainingseintrag können Sie die Eingabeeinheit jederzeit umstellen.",
    "preferredFigure": "Körperfigur auf der Bodymap",
    "preferredFigureHelp": "Wähle die Figur, mit der die Muscle Map gerendert wird. Vom Geschlecht entkoppelt — wir fragen nicht. Web zeigt vorerst nur die maskuline Figur, bis die Bibliothek getauscht wird; mobile unterstützt beide.",
    "figure_masculine": "Maskulin",
    "figure_feminine": "Feminin",
    "save": "Speichern",
    "saving": "Wird gespeichert…",
    "saved": "Profil gespeichert.",
    "agePrefix_under_18": "Unter 18",
    "age_18-24": "18-24",
    "age_25-29": "25-29",
    "age_30-34": "30-34",
    "age_35-39": "35-39",
    "age_40-44": "40-44",
    "age_45-49": "45-49",
    "age_50-54": "50-54",
    "age_55-59": "55-59",
    "age_60-64": "60-64",
    "age_65-69": "65-69",
    "age_70-plus": "70+",
    "bodyweight": "Körpergewicht (optional)",
    "bodyweightPlaceholder": "z. B. 78",
    "bodyweightHelp": "Wird nur zur Berechnung der effektiven Last bei Eigengewichtsübungen verwendet. Niemals aggregiert, niemals geloggt, beim Kontolöschen entfernt.",
    "errBodyweight": "Geben Sie ein Körpergewicht zwischen 20 und 300 kg (oder den Gegenwert in lb) ein.",
    "apk": {
      "title": "Android-APK (Test-Build)",
      "hint": "Test-Build ausschließlich für die Familie. Aktivieren Sie unter Android im Browser „Installation aus unbekannten Quellen“ und öffnen Sie anschließend die Datei.",
      "download": "APK herunterladen"
    },
    "email": "E-Mail",
    "metaTitle": "Sitzung"
  },
  "workout": {
    "title": "Trainings",
    "loading": "Trainings werden geladen…",
    "empty": "Noch keine Trainings erfasst.",
    "logNew": "Training erfassen",
    "startedAt": "Wann",
    "exercise": "Übung",
    "exercisePlaceholder": "Übung auswählen",
    "errPickExercise": "Wählen Sie eine Übung aus dem Katalog.",
    "catalogEmptyCoach": "Der Katalog ist leer. Fügen Sie mindestens eine Übung hinzu, bevor Sie ein Training erfassen.",
    "catalogEmptyAthlete": "Der Katalog ist leer. Eine Ihrer Coaches muss zuerst Übungen anlegen, bevor Sie ein Training erfassen können.",
    "setsLegend": "Sätze",
    "set": "Satz",
    "reps": "Wdh.",
    "amrapHint": "AMRAP — den vorgegebenen Mindestwert übertreffen",
    "weight": "Gewicht",
    "extra": "Zusatz (+/−)",
    "unit": "Einheit",
    "rpe": "RPE",
    "addSet": "Satz hinzufügen",
    "removeSet": "Satz entfernen",
    "notes": "Notizen (optional)",
    "setNoteToggle": "Notiz zu diesem Satz hinzufügen",
    "setNotePlaceholder": "Was an diesem Satz anders war",
    "draftRecoveryHeadline": "Sie haben ein unvollendetes Training vom {{when}}.",
    "draftRecoveryContinue": "Fortsetzen",
    "draftRecoveryDiscard": "Verwerfen",
    "maxBumpAvailable": "{{exercise}}: neuer MAX bei {{value}}",
    "maxBumpConfirm": "↑ Bestätigen",
    "maxBumpSaving": "Wird gespeichert…",
    "prefillFromDate": "Aus dem Training vom {{date}} vorausfüllen?",
    "prefillAccept": "Übernehmen",
    "prefillDismiss": "Überspringen",
    "savePromptTitle": "Vor dem Speichern prüfen",
    "savePromptContinue": "Zurück zum Training",
    "savePromptAnyway": "Trotzdem speichern",
    "unmarkedPromptBody": "{{count}} Sätze mit Werten, aber ohne Abschluss-Markierung.",
    "unmarkedPromptFail": "Als fehlgeschlagen markieren und speichern",
    "unmarkedPromptComplete": "Als erledigt markieren und speichern",
    "outlierPromptBody": "{{count}} Einträge wirken ungewöhnlich:",
    "outlierItem": "{{exercise}}: {{weight}} (historisches Max {{expected}})",
    "outlierE1rmItem": "{{exercise}}: geschätztes 1RM {{e1rm}} (historisches Max {{expected}})",
    "outlierPerImplementItem": "{{exercise}}: {{weight}} ist etwa das Doppelte deines üblichen {{expected}} — hast du das Gewicht EINER Hantel eingetragen oder das von beiden zusammen?",
    "outlierRepsItem": "{{exercise}}: {{reps}} Wiederholungen — wirkt zu hoch",
    "outlierZeroWeightItem": "{{exercise}}: {{reps}} Wiederholungen ohne Gewicht",
    "save": "Speichern",
    "saving": "Wird gespeichert…",
    "saved": "Training gespeichert.",
    "savedEdit": "Training aktualisiert.",
    "savedEditOldRemains": "Training aktualisiert, aber die vorherige Version steht noch im Verlauf. Bitte manuell löschen.",
    "deleted": "Training gelöscht.",
    "cancel": "Abbrechen",
    "errNoSets": "Fügen Sie mindestens einen gültigen Satz hinzu.",
    "creatingTitle": "Neues Training",
    "editingTitle": "Training bearbeiten",
    "exerciseN": "Übung {{n}}",
    "addExercise": "Weitere Übung hinzufügen",
    "removeExercise": "Übung entfernen",
    "removeExerciseConfirm": "{{name}} aus diesem Training entfernen? Bereits eingetragene Sätze gehen verloren.",
    "groupAlignTitle": "Unterschiedliche Satzanzahl",
    "groupAlignBody": "Die Mitglieder dieser Gruppe haben zwischen {{shortest}} und {{longest}} Sätzen. Aneinander angleichen, damit die Runden zusammenpassen?",
    "groupAlignPad": "+ Auf {{n}} erweitern",
    "groupAlignTrim": "− Auf {{n}} kürzen",
    "groupAlignTrimWarning": "Kürzen löscht bereits erfasste Sätze, und das lässt sich nicht rückgängig machen.",
    "groupAlignTrimHint": "Löscht die überzähligen Sätze bei jedem Mitglied der Gruppe. Nicht rückgängig zu machen.",
    "groupAlignKeep": "So lassen",
    "splitGroup": "Auflösen",
    "splitGroupTitle": "Gruppe auflösen?",
    "splitGroupBody": "Die Übungen behalten ihre Sätze und bleiben im Workout, sind nur nicht mehr verknüpft. Du kannst sie jederzeit wieder gruppieren.",
    "splitGroupConfirm": "Auflösen",
    "removeRoundConfirmTitle": "Diese Runde entfernen?",
    "removeRoundConfirmBody": "Runde {{n}} von {{names}} wird gemeinsam entfernt.",
    "bilateral": "Bilateral",
    "unilateral": "Unilateral",
    "edit": "Bearbeiten",
    "repeat": "Wiederholen",
    "delete": "Löschen",
    "deleting": "Wird gelöscht…",
    "deleteConfirm": "Dieses Training löschen?",
    "distance": "m",
    "duration": "s",
    "cardioDuration": "Dauer",
    "cardioDistance": "Distanz",
    "cardioWeight": "Gewicht",
    "cardioHr": "Ø Puls",
    "cardioCalories": "Kalorien",
    "cardioOptionalsShow": "Weitere Felder",
    "cardioOptionalsHide": "Weitere Felder",
    "dateEditor": "Datum & Dauer",
    "dateLabel": "Datum",
    "startTimeLabel": "Start",
    "endTimeLabel": "Ende",
    "durationLabel": "Dauer",
    "side": "Seite",
    "sideLeft": "Links",
    "sideRight": "Rechts",
    "sideBoth": "Beide",
    "showRpe": "RPE erfassen",
    "showDuration": "Dauer erfassen",
    "rir": "RIR {{n}}",
    "swap": "Tauschen",
    "swapHint": "Bank besetzt? Wählen Sie eine ähnliche Übung.",
    "descriptionToggle": "Beschreibung ein-/ausblenden",
    "failShort": "F",
    "failToggle": "Satz als gescheitert markieren",
    "failHint": "Letzte Wiederholung verfehlt. Zählt im Volumen, von PR ausgeschlossen.",
    "startRest": "Pausentimer starten",
    "restStartDefault": "Pause starten ({{n}}s)",
    "restStartCustom": "Pause starten ({{n}}s, Übungsstandard)",
    "setComplete": "Satz als erledigt markieren",
    "setCompleteHint": "Satz abstempeln und {{n}} s Pause starten.",
    "setCompleteHintCustom": "Satz abstempeln und {{n}} s Pause starten (Übungsstandard).",
    "setUndo": "Markierung zurücknehmen",
    "setUndoHint": "Erneut tippen, um zurückzunehmen und den Pausentimer zurückzusetzen.",
    "restLeft": "Pause",
    "restDone": "Zeit abgelaufen",
    "restStop": "Stopp",
    "restPause": "Anhalten",
    "restResume": "Fortsetzen",
    "restSound": "Signal am Pausenende",
    "instructions": "Hinweise des Coaches (optional)",
    "instructionsPlaceholder": "Fokus der Einheit, was bei Zeitnot weggelassen werden darf, Absicht.",
    "lastTime": "Letztes",
    "lastToday": "heute",
    "lastDaysAgo": "vor {{n}} T",
    "dropsetShort": "Drop",
    "dropsetToggle": "Dropset-Kette hinzufügen",
    "dropsetHint": "Weitere Wiederholungen ohne Pause anhängen.",
    "dropsetTitle": "Dropset",
    "dropsetVariant": "Variante",
    "dropsetClassical": "Klassisch (Last reduzieren)",
    "dropsetMyorep": "Myo-Rep (gleiche Last)",
    "dropsetHintClassical": "Last um 10–30 % senken und bis zum Versagen weiterführen. Keine Pause.",
    "dropsetHintMyorep": "Gleiche Last, weniger Wiederholungen, 10–20 s Atempause, wiederholen.",
    "dropsetSameLoad": "= oben",
    "dropsetAddStep": "Drop hinzufügen",
    "dropsetRemove": "Entfernen",
    "dropsetRemoveConfirm": "Du hast {{n}} Drop-Steps. Zurück in einen normalen Satz konvertieren und sie verwerfen?",
    "dropsetRemoveStep": "Drop entfernen",
    "groupLabel": "Gruppe",
    "groupNone": "(keine)",
    "groupCreate": "Neu anlegen",
    "groupNewSuperset": "Neues Superset",
    "groupNewCircuit": "Neuer Zirkel",
    "groupJoinExisting": "Bestehender Gruppe beitreten",
    "groupLeave": "Gruppe auflösen",
    "groupSharedHint": "Geteilt. Öffnen Sie eine weitere Übung und wählen Sie dieselbe Gruppe aus der Liste, um sie zu verknüpfen.",
    "supersetN": "Superset {{n}}",
    "circuitN": "Zirkel {{n}}",
    "supersetDerived": "Superset (auto)",
    "supersetDerivedTitle": "Erkannt aus dem Wechsel der Sätze in dieser Einheit",
    "playActiveTitle": "Aktive Übung — zuletzt abgeschlossener Satz",
    "errGroupKindMixed": "Eine Gruppe darf Superset und Zirkel nicht mischen. Wählen Sie einen Typ.",
    "exerciseNew": "Neue Übung",
    "cardMenu": "Übungsoptionen",
    "menuReplace": "Übung ersetzen",
    "menuGroup": "Gruppe / Superset",
    "menuMoveUp": "Nach oben verschieben",
    "menuMoveDown": "Nach unten verschieben",
    "menuShowNotes": "Notizen anzeigen",
    "menuHideNotes": "Notizen ausblenden",
    "menuShowDescription": "Beschreibung anzeigen",
    "menuHideDescription": "Beschreibung ausblenden",
    "tipAlternatives": "Alternative Übungen",
    "tipCoachNote": "Coach-Notiz",
    "perImplementHint": "Zwei im Einsatz, oder eine Seite nach der anderen? Trag das Gewicht von einem ein. Die App zählt beide (×2).",
    "tipProgramNote": "In diesem Training",
    "tipNoAlternatives": "Keine ähnlichen Übungen im Katalog",
    "tipClose": "Schließen",
    "painBanner": {
      "red": "Belastet einen schmerzhaften Muskel",
      "yellow": "Vorsicht: belastet einen markierten Muskel",
      "green": "Kein Schmerzrisiko"
    },
    "setCycleHint": "Tippen: erledigt · erneut: gescheitert · erneut: zurück",
    "setStatePending": "Satz offen",
    "setStateDone": "Satz erledigt",
    "setStatePr": "Satz erledigt, persönliche Bestleistung",
    "setStateFailed": "Satz als gescheitert markiert",
    "prShort": "🏆",
    "addDrop": "+ Drop",
    "groupBannerSuperset": "SUPERSET",
    "groupBannerCircuit": "ZIRKEL",
    "groupAutoTag": "AUTO",
    "groupAutoConfirm": "Sperren",
    "groupAutoConfirmAria": "Gruppe sperren: Erkennung beenden und Übungen verbunden halten",
    "groupAutoDismiss": "Auflösen",
    "groupAutoDismissAria": "Erkennung ignorieren: Übungen zurück zu Einzelübungen",
    "groupAddSetAll": "Satz zu allen hinzufügen",
    "nameLabel": "Name (optional)",
    "namePlaceholder": "z. B. Push A · Lower Quad-Dominant",
    "durationStepperA11y": "Dauer-Stepper",
    "rirLabel": "RIR",
    "showRir": "RIR erfassen",
    "maxDownA11y": "MAX ist möglicherweise gesunken",
    "animationOf": "Animation von {{name}}",
    "animationZoomHint": "Öffnet die Animation im Vollbild",
    "closeAnimation": "Animation schließen",
    "showAnimation": "Animation anzeigen",
    "showBodyMap": "Beanspruchte Muskeln anzeigen",
    "pageOf": "{{current}} von {{total}}",
    "pagerDot": "{{target}}, {{current}} von {{total}}"
  },
  "program": {
    "title": "Programme",
    "help": "Mehrwöchige Trainingszyklen. Phase 5.1 liefert das Gerüst: Name, Wochen, Einheiten pro Woche. Der Slot- und Progressions-Builder folgt.",
    "new": "Neues Programm",
    "newTitle": "Neues Programm",
    "name": "Name",
    "namePlaceholder": "z.B. Powerbuilding 6 Wochen",
    "cycleWeeks": "Wochen pro Zyklus",
    "sessionsPerWeek": "Einheiten pro Woche",
    "description": "Beschreibung",
    "descriptionPlaceholder": "Wofür der Zyklus dient, an wen er sich richtet, Hinweise für die Athleten.",
    "create": "Erstellen",
    "creating": "Neues Programm: {{name}}",
    "cancel": "Abbrechen",
    "delete": "Löschen",
    "deleteConfirm": "Bestätigen?",
    "deleteConfirmYes": "Ja, löschen",
    "loading": "Programme werden geladen…",
    "empty": "Noch keine Programme. Erstellen Sie eines, um einen mehrwöchigen Zyklus zu planen.",
    "statusDraft": "Entwurf",
    "statusActive": "Aktiv",
    "statusArchived": "Archiviert",
    "cycleWeeksLabel": "{{n}}-Wochen-Zyklus",
    "sessionsPerWeekLabel": "{{n}}× / Woche",
    "slotCount": "{{n}} Slot(s)",
    "skeletonHint": "Nur das Gerüst. Slots werden in der nächsten Phase gefüllt.",
    "sessionDefaultName": "Einheit {{n}}",
    "edit": "Bearbeiten",
    "editing": "Bearbeiten: {{name}}",
    "backToList": "Zurück zu den Programmen",
    "save": "Speichern",
    "saving": "Wird gespeichert…",
    "errSave": "Programm konnte nicht gespeichert werden.",
    "metaLegend": "Programm",
    "status": "Status",
    "metaCyclesLive": "Strukturänderungen (Tage, Wochen) werden sofort übernommen",
    "ordinalSession": "{{n}}. Einheit",
    "sessionName": "Name der Einheit",
    "slotN": "Slot {{n}}",
    "addSlot": "Slot hinzufügen",
    "removeSlot": "Entfernen",
    "moveUp": "Nach oben verschieben",
    "moveDown": "Nach unten verschieben",
    "exercise": "Übung",
    "exercisePick": "Übung auswählen",
    "setsLegend": "Sätze",
    "addSet": "Satz hinzufügen",
    "removeSet": "Satz entfernen",
    "reps": "Wdh",
    "setNotesPlaceholder": "Notiz zum Satz (optional)",
    "set": "Satz",
    "intensityKind": "Intensität",
    "intensityNone": "Frei",
    "intensityPercent": "% des MAX",
    "intensityAbs": "kg (absolut)",
    "intensityRpe": "RPE",
    "intensity_percent-of-max": "Prozent",
    "intensity_absolute": "Gewicht (kg)",
    "intensity_rpe": "RPE",
    "weekShort": "W{{n}}",
    "previewShow": "Vorschau",
    "previewHide": "Vorschau ausblenden",
    "previewMuscles": "Beanspruchte Muskeln",
    "previewSets": "{{n}} Sätze",
    "previewEmptySession": "Keine Slots in dieser Einheit.",
    "previewEmptyProgram": "Noch keine Slots. Öffnen Sie Bearbeiten, um welche hinzuzufügen.",
    "start": "Einheit starten",
    "startCancel": "Abbrechen",
    "startGo": "Starten",
    "starting": "Wird gestartet…",
    "startWeek": "Woche",
    "startSession": "Einheit",
    "progressNext": "Nächste: W{{w}} · Einheit {{s}}",
    "instructions": "Anweisungen",
    "instructionsPlaceholder": "Tempo, Pausendauer, technischer Fokus, RPE-Ziel.",
    "amrapLastSet": "AMRAP im letzten Satz",
    "maxAttempt": "1MAX-Versuch",
    "amrapBadge": "AMRAP",
    "maxBadge": "1MAX",
    "slotCycleHint": "Angewendet über die {{n}} Wochen des Zyklus.",
    "catalogLoading": "Übungskatalog wird geladen…",
    "builderComingSoon": "Der Slot- und Progressions-Builder folgt in Phase 5.2. Vorerst legt das eine leere Hülle an, die Sie löschen oder später füllen können.",
    "errCycleWeeks": "Die Wochen müssen zwischen 1 und 12 liegen.",
    "errSessionsPerWeek": "Die Einheiten pro Woche müssen zwischen 1 und 7 liegen.",
    "errName": "Der Programmname ist erforderlich.",
    "errEmptyDay": "Jeder Trainingstag braucht mindestens eine Übung.",
    "errSchema": "Ungültige Programmdaten.",
    "errCreate": "Programm konnte nicht erstellt werden.",
    "errCode": {
      "sessionNameEmpty": "Jeder Trainingstag braucht einen Namen.",
      "slotNoExercise": "Wähle für jeden Slot eine Übung.",
      "slotNoSets": "Jede Übung braucht mindestens einen Satz.",
      "slotAllWeeksInactive": "Eine Übung ist in allen Wochen deaktiviert. Aktiviere eine Woche oder entferne sie.",
      "rowWidthMismatch": "Eine Satzzeile passt nicht zur Anzahl der Wochen. Öffne die Übung neu und versuche es erneut.",
      "invalidReps": "Prüfe die Wiederholungen: nutze eine Zahl wie 8, oder 8+ für AMRAP.",
      "groupKindMixed": "Ein Supersatz mischt Satztypen. Gib seinen Übungen denselben Typ.",
      "schemaInvalid": "Ungültige Programmdaten.",
      "noSession": "Es gibt kein Training zum Speichern.",
      "planNameEmpty": "Der Plan-Name ist erforderlich.",
      "planNoExercises": "Füge dem Plan mindestens eine Übung hinzu.",
      "invalidIntensityValue": "Prüfe den Intensitätswert: er muss eine Zahl sein.",
      "weightOutOfRange": "Dieses Gewicht liegt außerhalb des Bereichs.",
      "pctOutOfRange": "Der Prozentsatz muss zwischen 0 und 200 liegen.",
      "rpeOutOfRange": "RPE muss zwischen 1 und 10 liegen.",
      "rirOutOfRange": "RIR muss zwischen 0 und 10 liegen.",
      "unknownIntensityKind": "Unbekannter Intensitätstyp.",
      "invalidSeconds": "Prüfe die Sekunden: ein Satz auf Zeit braucht eine Dauer, in ganzen Sekunden bis 3600."
    },
    "cardMenu": "Slot-Menü",
    "menuGroup": "Gruppe",
    "groupNone": "Keine Gruppe",
    "groupJoinExisting": "Bestehender Gruppe beitreten",
    "groupCreate": "Erstellen",
    "groupNewSuperset": "Neuer Superset",
    "groupNewCircuit": "Neuer Zirkel",
    "groupSupersetN": "Superset {{letter}}",
    "groupCircuitN": "Zirkel {{letter}}",
    "assignTo": "Athleten zuweisen",
    "assignToHelp": "Das Programm wird der Bibliothek jeder Athletin oder jedes Athleten hinzugefügt. Eine aktive Trainerverbindung ist erforderlich.",
    "assignSelf": "Sie (Autor)",
    "addAssignee": "Hinzufügen",
    "removeAssignee": "Entfernen",
    "assigneePlaceholder": "athlet@beispiel.com",
    "follow": "Folgen",
    "unfollow": "Nicht mehr folgen",
    "followHint": "Diesem Programm folgen (erscheint unter Laufend)",
    "publish": "Veröffentlichen",
    "unpublish": "Zurück zum Entwurf",
    "publishAndFollow": "Veröffentlichen und folgen",
    "publishHint": "Dieses Programm zum Folgen verfügbar machen",
    "chipDraft": "Entwurf",
    "chipPublished": "Veröffentlicht",
    "chipFollowed": "Folge ich",
    "kindShortAbsolute": "KG",
    "kindShortAbsoluteLb": "LB",
    "kindShortPercent": "%MAX",
    "kindShortHistory": "VERL",
    "kindShortRpe": "RPE",
    "kindShortRir": "RIR",
    "languageUndeclared": "Sprache",
    "languageA11y": "Sprache zum Schreiben",
    "languageSwitchQuestion": "In welcher Sprache schreibst du?",
    "languageDeclareQuestion": "In welcher Sprache ist dieses Programm geschrieben?",
    "languageFootnote": "Übersetzungen sind optional. Ein Programm in einer Sprache ist vollständig.",
    "languageDeclareFootnote": "Es wird nichts übersetzt: das hält nur die Sprache fest.",
    "languageAuto": "Maschinelle Übersetzung",
    "languageNotYetWritten": "Noch keine Fassung auf {{lang}}. Der Text auf {{original}} bleibt erhalten.",
    "setBound": "Grenze",
    "boundReps": "Wdh",
    "boundTime": "Zeit",
    "boundOpen": "Offen",
    "workSeconds": "Arbeit (s)",
    "restSeconds": "Pause (s)",
    "restSecondsPlaceholder": "auto",
    "prescribeTime": "Zeit",
    "prescribeTimeA11y": "Arbeit und Pause in Sekunden vorgeben",
    "seconds": "Sekunden",
    "amrapNotWithTime": "Ein {{secs}}s-Satz kann kein AMRAP sein: ein Plan kann nicht fragen, wie viele du schaffst. Nimm das + oder die Zeit weg.",
    "workSecondsRequired": "Wie lange?"
  },
  "me": {
    "targets": {
      "title": "Ziele",
      "historyByCoach": "Dein Coach",
      "errNotFound": "Deine Ziele wurden nicht gefunden. Geh zurück und versuch es erneut."
    }
  },
  "coach": {
    "title": "Coach und Athleten",
    "subtitle": "Athleten, die Sie trainieren, und Trainer, die Sie betreuen. Eine Einladung erfordert die Zustimmung beider Seiten, bevor Zuweisungen fließen können.",
    "subLabel": "sub",
    "inviteAthleteLabel": "Athletin oder Athlet per E-Mail einladen",
    "invitePlaceholder": "athlet@beispiel.com",
    "inviteNotePlaceholder": "Notiz (optional)",
    "inviteSend": "Einladung senden",
    "inviteSending": "Wird gesendet…",
    "inviteSent": "Einladung versandt. Die Athletin oder der Athlet sieht sie beim nächsten Anmelden.",
    "athletesHeading": "Athleten, die ich trainiere",
    "coachesHeading": "Trainer, die mich betreuen",
    "athletesEmpty": "Noch keine Athleten. Senden Sie oben eine Einladung.",
    "pendingInLabel": "Wartet auf Ihre Antwort",
    "pendingOutLabel": "Wartet auf deren Antwort",
    "activeLabel": "Aktiv",
    "accept": "Annehmen",
    "decline": "Ablehnen",
    "cancel": "Einladung abbrechen",
    "revoke": "Widerrufen",
    "leave": "Coach verlassen",
    "busy": "Wird verarbeitet…",
    "loading": "Wird geladen…",
    "loadFailed": "Laden fehlgeschlagen. Neu laden, um es erneut zu versuchen.",
    "errCode": {
      "invalid_email": "Diese E-Mail-Adresse ist ungültig.",
      "email_not_found": "Kein verifiziertes Konto mit dieser E-Mail-Adresse.",
      "peer_required": "Geben Sie eine E-Mail-Adresse oder einen Sub an.",
      "edge_exists": "Eine Verbindung mit diesem Partner besteht bereits.",
      "userpool_not_configured": "Server falsch konfiguriert: User Pool nicht verfügbar.",
      "io_error": "Netzwerk- oder Serverfehler. Erneut versuchen.",
      "not_pending": "Diese Einladung steht nicht mehr aus.",
      "wrong_party": "Nur die Gegenseite kann diese Einladung annehmen."
    },
    "dashboard": {
      "title": "Team-Übersicht",
      "unnamedAthlete": "Athlet",
      "empty": "Noch keine Athleten",
      "emptySub": "Lade Athleten unter Coach & Athleten ein, um sie hier zu sehen.",
      "loading": "Lade dein Team…",
      "loadFailed": "Team konnte nicht geladen werden. Zum erneuten Versuch aktualisieren.",
      "noProgram": "Kein Programm",
      "kpiAssigned": "Athleten",
      "kpiActive": "Aktiv diese Woche",
      "kpiAttention": "Benötigen Aufmerksamkeit",
      "kpiAdherence": "Ø Einhaltung",
      "kpiSessions": "Einheiten diese Woche",
      "adherence": "Einhaltung",
      "lastToday": "heute",
      "lastNever": "nie trainiert",
      "lastDaysAgo": "vor {{count}} T",
      "flagStale": "Trainiert nicht",
      "flagUnderTarget": "Unter Ziel",
      "flagOnTrack": "Im Plan",
      "flagNoProgram": "Kein Programm"
    },
    "detail": {
      "back": "Zurück zum Team",
      "maxesTitle": "Aktuelle MAX",
      "maxesEmpty": "Noch keine MAX erfasst",
      "rhythmSummary": "Ø {{avg}}/Woche über {{weeks}} Wochen · letzte Woche: {{last}}",
      "effortTitle": "Effort-Abdeckung",
      "effortLabel": "Sätze mit erfasstem RIR",
      "effortSummary": "{{tagged}} von {{counted}} gezählten Sätzen, Aufwärmsätze eingeschlossen",
      "effortEra": "Effort-Daten beginnen am {{date}} · {{count}} frühere Sätze werden nicht gezählt",
      "effortNone": "Noch kein Satz trägt einen Effort-Wert, daher haben die Zahlen zu harten Sätzen und Zielen keine Grundlage.",
      "effortError": "Effort-Daten konnten nicht geladen werden.",
      "maxesSeeAll": "Alle anzeigen (+{{count}})",
      "maxesShowFewer": "Weniger anzeigen"
    },
    "targets": {
      "eyebrow": "Wochenziele",
      "edit": "Ziele bearbeiten",
      "degradedHint": "Dieser Athlet hat noch keine Wochenziele. Lege welche fest, um seine Woche an einem Ziel zu messen.",
      "noGrant": "Schreibgeschützt — der Athlet hat dir das Bearbeiten der Ziele nicht erlaubt.",
      "historyTitle": "Änderungsverlauf",
      "historyEmpty": "Noch keine Änderungen.",
      "historyByYou": "Du",
      "historyTruncated": "Zeige die letzten 1000 Änderungen.",
      "histGeneric": "Ziele aktualisiert",
      "histSet": "auf {{value}} gesetzt",
      "histRemoved": "entfernt",
      "histChanged": "{{from}} → {{to}}",
      "histLine": "{{label}} · {{metric}}: {{body}}",
      "historyLoading": "Wird geladen…",
      "errLoad": "Diese Ziele konnten nicht geladen werden. Geh zurück und versuch es erneut.",
      "errStale": "Diese Ziele haben sich während deiner Bearbeitung geändert. Neu laden und erneut anwenden.",
      "errNoGrant": "Der Athlet hat dir das Bearbeiten der Ziele nicht erlaubt.",
      "errNotCoach": "Du bist nicht der Coach dieses Athleten.",
      "errMultiAssignee": "Dieses Programm wird von mehr als einem Athleten genutzt.",
      "errRetry": "Lädt noch — versuch es gleich noch einmal.",
      "errNotFound": "Dieses Programm existiert nicht mehr.",
      "errOffline": "Speichern fehlgeschlagen. Prüfe deine Verbindung und versuch es erneut."
    }
  },
  "plans": {
    "title": "Pläne",
    "help": "Entwerfen Sie eine Trainingseinheit für sich. Vorgaben in absoluten Kilogramm oder als Prozentsatz Ihres MAX, beim Start des Plans in kg umgerechnet.",
    "loading": "Pläne werden geladen…",
    "empty": "Noch keine Pläne. Legen Sie einen an, um eine Einheit vorzubereiten.",
    "todayPill": "Heute",
    "add": "Plan hinzufügen",
    "edit": "Bearbeiten",
    "start": "Starten",
    "cancel": "Abbrechen",
    "save": "Speichern",
    "saving": "Wird gespeichert…",
    "saved": "Plan gespeichert.",
    "savedEdit": "Plan aktualisiert.",
    "deleted": "Plan gelöscht.",
    "delete": "Löschen",
    "deleting": "Wird gelöscht…",
    "deleteConfirm": "Diesen Plan löschen?",
    "creatingTitle": "Neuer Plan",
    "editingTitle": "Plan bearbeiten",
    "name": "Name",
    "namePlaceholder": "z. B. Kniebeugen-Tag",
    "scheduledFor": "Geplant für (optional)",
    "pickDate": "Datum wählen",
    "pickDateHint": "Öffnet die Datumsauswahl",
    "clearDate": "Datum löschen",
    "noDate": "Nicht gesetzt",
    "notes": "Notizen (optional)",
    "rpeEnabledLabel": "RPE-Spalte im Logger anzeigen",
    "rpeEnabledHelp": "Wenn aktiv, öffnen aus diesem Plan gestartete Sessions mit sichtbarer RPE-Spalte. Die Athletin/der Athlet kann sie pro Session weiterhin umschalten.",
    "exercise": "Übung",
    "exercisePlaceholder": "Übung wählen",
    "exerciseN": "Übung {{n}}",
    "removeExercise": "Übung entfernen",
    "addExercise": "Weitere Übung hinzufügen",
    "setsLegend": "Sätze",
    "targetReps": "Wdh.",
    "targetWeight": "Gewicht",
    "targetKind": "Einheit",
    "targetRpe": "RPE",
    "noMaxYet": "kein MAX",
    "addSet": "Satz hinzufügen",
    "removeSet": "Satz entfernen",
    "statusDraft": "Entwurf",
    "statusScheduled": "Geplant",
    "statusCompleted": "Abgeschlossen",
    "statusSkipped": "Übersprungen",
    "errNotSignedIn": "Sie müssen angemeldet sein.",
    "errNameRequired": "Geben Sie dem Plan einen Namen.",
    "errPickExercise": "Wählen Sie eine Übung aus dem Katalog.",
    "errNoSets": "Fügen Sie mindestens einen gültigen Satz hinzu.",
    "errGroupKindMixed": "Zwei Einträge teilen sich eine Gruppen-ID, sind aber als Superset und Zirkel markiert. Bitte einheitlich machen und neu speichern.",
    "assignTo": "Zusätzlich zuweisen an",
    "assignToHelp": "Geben Sie eine E-Mail-Adresse ein und drücken Sie Enter. Die Adresse muss bereits ein Konto haben, sonst wird der Plan abgelehnt.",
    "addAssignee": "Hinzufügen",
    "removeAssignee": "Entfernen",
    "assigneePlaceholder": "name@beispiel.de",
    "exerciseNew": "Übung wählen",
    "setIndex": "Satz {{n}}",
    "cardMenu": "Kartenmenü",
    "menuGroup": "Gruppe",
    "menuMoveUp": "Nach oben",
    "menuMoveDown": "Nach unten",
    "groupNone": "Keine Gruppe",
    "groupJoinExisting": "Bestehender Gruppe beitreten",
    "groupCreate": "Erstellen",
    "groupNewSuperset": "Neuer Superset",
    "groupNewCircuit": "Neuer Zirkel",
    "groupSupersetN": "Superset {{letter}}",
    "groupCircuitN": "Zirkel {{letter}}",
    "details": "Details",
    "exercisesLabel": "Übungen",
    "editorEmpty": "Noch keine Übungen. Füge eine hinzu, um diesen Plan zu erstellen.",
    "selectExercisePrompt": "Wähle eine Übung, um ihre Sätze zu bearbeiten.",
    "addExerciseCta": "Übung hinzufügen",
    "removeExerciseConfirm": "Diese Übung entfernen?",
    "removeExerciseHint": "Einmal tippen zum Bestätigen, dann erneut tippen zum Entfernen.",
    "collapseExercise": "Übung einklappen",
    "supersetTag": "SUPERSATZ",
    "exerciseNoteLabel": "Übungsnotiz (optional)"
  },
  "templates": {
    "show": "Starter-Vorlagen durchsuchen",
    "hide": "Vorlagen ausblenden",
    "help": "Häufig verwendete Pläne und Programme als Vorlage. Klonen Sie eine in Ihr Konto — die Kopie gehört Ihnen, sie ändern oder löschen ohne die Vorlage zu berühren.",
    "loading": "Vorlagen werden geladen…",
    "empty": "Derzeit keine Vorlagen verfügbar.",
    "errLoad": "Vorlagen konnten nicht geladen werden.",
    "clone": "In mein Konto klonen",
    "cloning": "Wird geklont…",
    "cloned": "„{{name}}\" geklont.",
    "alreadyCloned": "Bereits geklont",
    "difficultyBeginner": "Anfänger",
    "difficultyIntermediate": "Mittel",
    "difficultyAdvanced": "Fortgeschritten",
    "planMeta": "{{n}} Übung(en)",
    "programMeta": "{{weeks}}-Wochen-Zyklus · {{sessions}}× / Woche"
  },
  "maxes": {
    "title": "Maxima",
    "countLabel_one": "{{count}} gesetzt",
    "countLabel_other": "{{count}} gesetzt",
    "help": "Das MAX ist, was Sie heute heben können, von Ihnen festgelegt. Programme verwenden es als Prozentbasis. Das geschätzte 1RM im Fortschritt dient nur zur Information.",
    "loading": "Maxima werden geladen…",
    "empty": "Noch keine Maxima eingetragen. Legen Sie eines an, um prozentbasiertes Training anzusteuern.",
    "add": "Maximum hinzufügen",
    "edit": "Bearbeiten",
    "delete": "Löschen",
    "deleteAction": "MAX löschen",
    "deleting": "Wird gelöscht…",
    "deleted": "MAX gelöscht.",
    "deleteConfirm": "MAX für {{name}} löschen? Der Verlauf wird ebenfalls entfernt. Der nächste Seed aus dem Verlauf kann ihn aus den Trainings neu setzen.",
    "exercise": "Übung",
    "exercisePlaceholder": "Übung auswählen",
    "value": "Wert",
    "source": "Quelle",
    "sourceManual": "Manuell eingegeben",
    "sourceTested": "Im Studio getestet",
    "sourceDerived": "Aus einem geloggten Satz abgeleitet",
    "sourceCalculated": "Aus Historie geschätzt",
    "sourceImported": "Importiert",
    "notes": "Notizen (optional)",
    "save": "Speichern",
    "saving": "Wird gespeichert…",
    "saved": "Maximum gespeichert.",
    "cancel": "Abbrechen",
    "errPickExercise": "Wählen Sie eine Übung.",
    "errInvalidValue": "Geben Sie einen Wert zwischen 0 und 2000 ein.",
    "seed": {
      "start": "Aus Verlauf vorschlagen",
      "loading": "Verlauf wird gelesen…",
      "reviewIntro": "{{count}} Übungen haben einen belastbaren Top-Satz im Verlauf. Wählen Sie aus, welche als MAX übernommen werden. Übungen mit vorhandenem MAX werden übersprungen.",
      "selectAll": "Alle auswählen",
      "selectNone": "Keine auswählen",
      "fromSet": "aus {{weight}} × {{reps}}",
      "cancel": "Abbrechen",
      "apply": "{{count}} MAX setzen",
      "applying": "Speichern: {{done}} / {{total}}",
      "applied": "{{count}} MAX aus dem Verlauf gesetzt.",
      "noneApplicable": "Nichts zu setzen. Entweder hat jede Übung bereits einen MAX, oder es wurde kein belastbarer Verlauf gefunden.",
      "close": "Schließen"
    }
  },
  "progress": {
    "coverageTitle": "Muskelabdeckung",
    "coverageSubtitle": "vs Wochenziel",
    "coverageTopTrained": "Deine meisttrainierten Muskeln diese Woche.",
    "coverageLead": "Unter deinem Wochenziel: {{count}}",
    "coverageAllGood": "Jeder Zielmuskel ist diese Woche im Plan.",
    "coverageAvg": "Ø {{n}}/Wo",
    "coverageSeeAll": "Alle Muskeln anzeigen (+{{count}})",
    "coverageShowFewer": "Weniger anzeigen",
    "detailsTitle": "Mehr Details",
    "detailsSubtitle": "Vertiefte Trainingsanalysen",
    "period": {
      "days": "{{days}} T",
      "painDays": "7 / {{days}} T",
      "selectorLabel": "Analysefenster"
    },
    "title": "Fortschritt",
    "show": "Anzeigen",
    "hide": "Ausblenden",
    "help": "Das MAX legen Sie selbst fest; das geschätzte 1RM nach Epley dient als Referenz. Das Volumen ist die Summe aus Gewicht mal Wiederholungen für die Einheit.",
    "e1rm": "Geschätztes 1RM",
    "max": "MAX",
    "maxLabel": "MAX",
    "estimatedBadge": "geschätztes 1RM gestrichelt",
    "volume": "Volumen",
    "sessions": "{{n}} Einheiten",
    "prFound": "Persönliche Bestleistung bei {{weight}}.",
    "prUpdate": "MAX auf {{weight}} setzen",
    "prUpdating": "Wird aktualisiert…",
    "viewByExercise": "Pro Übung",
    "viewByTag": "Pro Tag",
    "noTags": "Noch keine getaggten Einheiten. Taggen Sie Übungen im Katalog, um das aggregierte Volumen hier zu sehen.",
    "totalVolume": "Gesamt {{weight}}",
    "recordsScope": "Bestleistungen",
    "recordsAllTime": "Allzeit",
    "recordsThisYear": "{{year}}",
    "filterPlaceholder": "Übungen filtern",
    "filterCount": "{{visible}} von {{total}}",
    "filterNoMatch": "Keine Übung passt zum Filter.",
    "coverageNoData": "Noch nichts zu bewerten — logge eine Einheit oder setze ein Wochenziel."
  },
  "cohort": {
    "compare": "Mit Vergleichsgruppe abgleichen (anonym)",
    "hide": "Vergleich ausblenden",
    "loading": "Vergleichsdaten werden geladen…",
    "empty": "Noch nicht genug Beiträge für einen Vergleich. Die Schwelle liegt bei zehn Personen in derselben Altersgruppe.",
    "contributors": "Basierend auf {{n}} anonymen Beiträgen mit angegebener Altersgruppe.",
    "yourGroup": "deine Gruppe"
  },
  "catalog": {
    "title": "Übungskatalog",
    "loading": "Wird geladen…",
    "empty": "Noch keine Übungen.",
    "seedStarter": "Startauswahl laden",
    "seeding": "Wird geladen…",
    "importTaxonomy": "Vollständige Übungsbibliothek importieren",
    "importTaxonomyUpsert": "Aus der Bibliothek aktualisieren",
    "importing": "Wird importiert…",
    "importDone": "Import abgeschlossen. {{created}} erstellt, {{upserted}} aktualisiert, {{skipped}} übersprungen, {{failed}} fehlgeschlagen.",
    "add": "Übung hinzufügen",
    "edit": "Bearbeiten",
    "cancel": "Abbrechen",
    "save": "Speichern",
    "create": "Anlegen",
    "saving": "Wird gespeichert…",
    "name": "Name",
    "namePlaceholder": "z. B. Kniebeuge",
    "primaryMuscle": "Hauptmuskel (optional)",
    "primaryMusclePlaceholder": "z. B. Quadrizeps",
    "primaryLabel": "Primäre Muskeln (mindestens einer)",
    "secondaryLabel": "Sekundäre Muskeln (optional)",
    "addMuscle": "+ Muskel hinzufügen",
    "removeMuscle": "Muskel entfernen",
    "errPrimaryRequired": "Wählen Sie mindestens einen primären Muskel.",
    "isBodyweight": "Eigengewichtsübung",
    "isBodyweightHelp": "Sätze erfassen Wiederholungen und eine optionale Zusatzlast, kein Hantelgewicht.",
    "hasP1RM": "Als Prozentsatz des MAX programmierbar",
    "hasP1RMHelp": "Erlaubt Plänen, ein Ziel als Anteil des MAX für diese Übung anzugeben.",
    "defaultRest": "Standardpause (s)",
    "defaultRestPlaceholder": "z. B. 180",
    "defaultRestHelp": "Sekunden, die der Pausentimer standardmäßig herunterzählt. Leer lassen für den App-Standard (90 s).",
    "defaultBar": "Gewicht der Spezialhantel (kg)",
    "defaultBarPlaceholder": "z. B. 7",
    "defaultBarHelp": "Curl-Stange 7, Trap-Bar 11, Landmine ~10. Der Plattenrechner öffnet mit diesem Wert vorausgewählt bei Sätzen dieser Übung. Leer lassen für die Voreinstellung des Menüs.",
    "pinnedNoteLabel": "Setup-Hinweis (optional)",
    "pinnedNotePlaceholder": "z. B. Rack-Höhe 4, Sicherheitsablagen 6, Pause 1s",
    "pinnedNoteHelp": "Wird im Logger als Banner unter dem Übungstitel angezeigt. Plan- und Slot-Notizen haben Vorrang, sobald sie gesetzt sind.",
    "noMuscle": "-",
    "bw": "BW",
    "p1rm": "1RM%",
    "errSlug": "Verwenden Sie lateinische Buchstaben im Namen, damit das System einen stabilen Bezeichner erzeugen kann.",
    "errSlugExists": "Eine Übung mit diesem Namen existiert bereits.",
    "searchPlaceholder": "Übungen suchen…",
    "region": "Region",
    "regionAll": "Alle Regionen",
    "region_lower": "Unterkörper",
    "region_posterior": "Hintere Kette",
    "region_chest": "Brust",
    "region_back": "Rücken",
    "region_shoulders": "Schultern",
    "region_arms": "Arme",
    "region_core": "Rumpf",
    "region_cardio": "Cardio",
    "region_other": "Sonstiges",
    "pattern": "Bewegungsmuster",
    "patternAll": "Alle Muster",
    "pattern_squat": "Kniebeuge",
    "pattern_hinge": "Hüftbeugung",
    "pattern_horizontal-push": "Horizontales Drücken",
    "pattern_vertical-push": "Vertikales Drücken",
    "pattern_horizontal-pull": "Horizontales Ziehen",
    "pattern_vertical-pull": "Vertikales Ziehen",
    "pattern_lunge": "Ausfallschritt",
    "pattern_carry": "Tragen",
    "pattern_core": "Rumpf",
    "pattern_isolation": "Isolation",
    "pattern_cardio": "Kardio",
    "pattern_other": "Sonstiges",
    "equipment": "Gerät",
    "equipmentAll": "Alle Geräte",
    "equipment_barbell": "Langhantel",
    "equipment_dumbbell": "Kurzhantel",
    "equipment_kettlebell": "Kettlebell",
    "equipment_cable": "Kabelzug",
    "equipment_machine": "Maschine",
    "equipment_bodyweight": "Eigengewicht",
    "equipment_band": "Band",
    "equipment_other": "Sonstiges",
    "clearFilters": "Filter zurücksetzen",
    "noResults": "Keine Übung entspricht diesen Filtern.",
    "tags": "Tags",
    "tagsHelp": "Frei wählbare Etiketten für Filter und Auswertungen. Slug eingeben und Enter drücken, oder Vorschlagen klicken, um aus den strukturierten Feldern zu starten.",
    "tagsPlaceholder": "z. B. compound, warmup, for-sandrine",
    "addTag": "Hinzufügen",
    "removeTag": "Tag entfernen",
    "suggestTags": "Vorschlagen",
    "description": "Beschreibung",
    "descriptionHelp": "Kurzer Hinweis im Katalog und als Tooltip im Logger. Die übrigen Sprachen werden automatisch ergänzt.",
    "descriptionPlaceholder": "Aufbau, zentrale Bewegungshinweise, typische Fehler…",
    "descriptionResetDefault": "Auf gebündelten Standard zurücksetzen",
    "locale_en": "EN",
    "locale_it": "IT",
    "locale_fr": "FR",
    "locale_de": "DE",
    "locale_ru": "RU",
    "equipment_treadmill": "Laufband",
    "equipment_exercise-bike": "Heimtrainer",
    "equipment_elliptical": "Crosstrainer",
    "equipment_rower": "Rudergerät",
    "equipment_stair-climber": "Stepper",
    "equipment_jump-rope": "Springseil",
    "equipment_battle-ropes": "Battle Ropes",
    "equipment_sled": "Schlitten",
    "deletedExercise": "Gelöschte Übung"
  },
  "swap": {
    "title": "Übung tauschen",
    "currentLabel": "Aktuell",
    "searchPlaceholder": "Im Katalog suchen…",
    "showAll": "Alle Übungen anzeigen",
    "noMatches": "Keine Übung entspricht der Suche.",
    "noSuggestions": "Keine ähnlichen über Tags gefunden. Aktivieren Sie „Alle anzeigen“, um den vollständigen Katalog zu durchsuchen.",
    "close": "Schließen",
    "reasonTags": "Gemeinsame Tags ×{{count}}",
    "reasonPrimary": "Gemeinsame Muskeln ×{{count}}",
    "reasonDifferentEquipment": "Anderes Gerät",
    "suggestedSection": "Vorschläge",
    "allSection": "Alle Übungen",
    "whichMachine": "Welche Maschine?",
    "defaultMachine": "Standardmaschine",
    "machineLabel": "Maschine {{letter}}",
    "setMachine": "Maschine wählen",
    "machineChoices": "Bekannte Maschinen: {{count}}",
    "newMachine": "Neue Maschine",
    "bandSession": "Einheit",
    "bandCurrentExercise": "Diese Übung",
    "bandOtherExercises": "Zu einer anderen Übung wechseln",
    "equipmentKey": "Gerät",
    "currentConsequence": "Bereits erfasste Sätze bleiben: es ändert sich nur das Gerät, auf dem sie vermerkt sind.",
    "unavailableTitle": "Nicht hier?",
    "unavailableBody": "Wähle das Gerät für {{exercise}}, das es bei {{place}} nicht gibt. Gespeichert wird nur, was du auswählst.",
    "unavailableConfirm": "Speichern",
    "unavailableOpen": "Gerät hier nicht verfügbar",
    "unavailableOpenHint": "Fragt, welches Gerät dieser Übung fehlt.",
    "unavailableBadge": "Nicht hier",
    "unavailableRestore": "Hier wieder verfügbar",
    "unavailableErrorTitle": "Speichern fehlgeschlagen",
    "unavailableErrorBody": "Das Gerät gilt hier weiterhin als verfügbar.",
    "unavailableConfirmHint": "Wähle mindestens eines aus, um zu speichern.",
    "pinDefaultMachine": "Hier immer das Standardgerät verwenden",
    "pinMachine": "Hier immer {{machine}} verwenden",
    "pinHint": "Hier wird nicht mehr gefragt, welches Gerät für diese Übung.",
    "pinErrorTitle": "Speichern fehlgeschlagen",
    "pinErrorBody": "Das Standardgerät hier ist unverändert.",
    "unpinDefaultMachine": "Hier nicht mehr immer das Standardgerät verwenden",
    "unpinMachine": "Hier nicht mehr immer {{machine}} verwenden",
    "pinnedFootnoteDefault": "Hier wird immer das Standardgerät verwendet.",
    "pinnedFootnoteMachine": "Hier wird immer {{machine}} verwendet.",
    "unpinHint": "Hier wird wieder gefragt, welches Gerät für diese Übung."
  },
  "tabs": {
    "workout": "Training",
    "plan": "Plan",
    "progress": "Fortschritt",
    "profile": "Profil",
    "catalog": "Katalog",
    "admin": "Admin",
    "workoutEyebrow": "Heutige Einheit",
    "planEyebrow": "Programmierung",
    "progressEyebrow": "Diagramme und Berichte",
    "profileEyebrow": "Konto und Maxima",
    "catalogEyebrow": "Übungskatalog",
    "adminEyebrow": "Admin-Konsole",
    "progressEmpty": "Erfassen Sie zuerst eine Einheit — Diagramme erscheinen, sobald Daten vorliegen."
  },
  "shell": {
    "navAria": "Hauptnavigation"
  },
  "theme": {
    "aria": "Design",
    "light": "Hell",
    "dark": "Dunkel",
    "auto": "Auto"
  },
  "import": {
    "title": "Trainingseinheiten aus CSV importieren",
    "help": "Laden Sie einen Export aus einem anderen Tracker hoch. Sie bestätigen, dass Sie der Eigentümer der Daten sind und die Verantwortung für das tragen, was in JackedLogs importiert wird. Bereits importierte Einheiten werden anhand der ID erkannt und übersprungen.",
    "sourceLabel": "Quellplattform",
    "source": {
      "strengthlog": "StrengthLog"
    },
    "sourceHint": {
      "strengthlog": "Aus StrengthLog: Einstellungen öffnen, Export wählen, dann Logs full export. Die CSV-Datei beliebig speichern und unten auswählen. Der ursprüngliche Dateiname spielt keine Rolle."
    },
    "languageDisclaimer": "Übungsnamen werden auf Englisch abgeglichen. Namen in anderen Sprachen werden als Übungsentwürfe angelegt und müssen im Katalog manuell umbenannt werden.",
    "consent": "Ich habe diese Datei aus meinem eigenen Konto exportiert und bin Eigentümer der Daten.",
    "fileLabel": "CSV-Datei",
    "parsing": "Datei wird gelesen…",
    "cancel": "Abbrechen",
    "confirm": "Import starten",
    "again": "Weitere Datei importieren",
    "done": "Import abgeschlossen",
    "seedMaxesPrompt": "MAX-Werte aus den importierten Workouts ableiten? Im Profil gibt es einen Ein-Klick-Vorschlag, der auf jedem importierten Satz basiert.",
    "seedMaxesGo": "MAX aus History übernehmen",
    "summary": {
      "rows": "{{count}} Zeilen",
      "sessions": "{{count}} Einheiten",
      "exercises": "{{count}} Übungen",
      "dateRange": "{{from}} bis {{to}}",
      "autoMatched": "{{count}} im Katalog gefunden",
      "draftsToCreate": "{{count}} Übungen werden als Entwurf angelegt",
      "unparseable": "{{count}} Namen ergeben keinen Slug und werden übersprungen",
      "unparseableShow": "Namen anzeigen"
    },
    "draftsCallout": "Entwürfe tragen das Flag auto_imported. Sie sind sofort zum Loggen nutzbar. Eine Athletin oder ein Coach kann sie später prüfen und befördern, Muskeln und Geräte ergänzen oder Duplikate zusammenführen.",
    "draftsProgress": "Entwürfe werden angelegt: {{done}} / {{total}}",
    "mappingsTitle": "Übungszuordnung",
    "mappingsStats": "{{matched}} automatisch zugeordnet · {{pending}} zu klären · {{resolved}} geklärt · {{skipped}} übersprungen",
    "allResolved": "Alle Übungen sind geklärt. Sie können den Import starten.",
    "confidenceHint": "Nächste Übereinstimmung: {{top}} ({{pct}}%)",
    "toggle": {
      "showResolved": "Geklärte einblenden ({{count}})",
      "hideResolved": "Geklärte ausblenden",
      "showMatched": "Automatisch zugeordnete einblenden ({{count}})",
      "hideMatched": "Automatisch zugeordnete ausblenden"
    },
    "action": {
      "create": "Als neue Übung anlegen",
      "pickExisting": "Vorhandene verwenden",
      "skip": "Überspringen"
    },
    "create": {
      "name": "Übungsname",
      "bodyweight": "Körpergewichtsübung (ohne externe Last)",
      "submit": "Anlegen",
      "submitting": "Wird angelegt…"
    },
    "pick": {
      "label": "Übung aus dem Katalog",
      "placeholder": "Eine auswählen…",
      "rememberAlias": "\"{{csvName}}\" für künftige Importe als Alias speichern",
      "submit": "Bestätigen",
      "submitting": "Wird gespeichert…"
    },
    "skip": {
      "help": "Sätze dieser Übung werden nicht importiert. Sie können die Entscheidung unten ändern.",
      "submit": "Überspringen bestätigen"
    },
    "resolved": {
      "auto": "→ {{name}} (auto)",
      "linked": "→ {{name}} (zugeordnet)",
      "linkedAlias": "→ {{name}} (zugeordnet, Alias gespeichert)",
      "created": "→ {{name}} (angelegt)",
      "skipped": "übersprungen",
      "undo": "Rückgängig"
    },
    "mapping": {
      "suggestions": "Vorschläge",
      "allCatalog": "Gesamter Katalog"
    },
    "progress": {
      "label": "{{done}} / {{total}} ({{pct}}%)",
      "tally": "Erstellt {{created}} · Bereits vorhanden {{duplicates}} · Fehlgeschlagen {{failed}}"
    },
    "report": {
      "created": "Erstellte Einheiten: {{count}}",
      "duplicates": "Bereits vorhanden: {{count}}",
      "draftsCreated": "Erstellte Übungsentwürfe: {{count}}",
      "invalid": "Ungültige Daten: {{count}}",
      "unknownExercise": "Unbekannte Übung: {{count}}",
      "failed": "Fehlgeschlagen: {{count}}",
      "detailsToggle": "Fehler anzeigen",
      "moreFailures": "und {{more}} weitere"
    },
    "errors": {
      "catalogNotReady": "Der Übungskatalog wird noch geladen. Warten Sie einen Moment und wählen Sie die Datei erneut aus.",
      "emptyFile": "Keine Zeilen in der Datei gefunden.",
      "missingColumns": "Fehlende Pflichtspalten: {{columns}}.",
      "parseFailed": "Die Datei konnte nicht gelesen werden.",
      "nothingToImport": "Nach dem Anlegen der Entwürfe ist nichts zu importieren. Bitte die Datei prüfen.",
      "draftsFailed": "Übungsentwürfe konnten nicht angelegt werden: {{message}}"
    }
  },
  "mobile": {
    "bodymap": {
      "muscle": {
        "chest": "Brust",
        "biceps": "Bizeps",
        "triceps": "Trizeps",
        "forearm": "Unterarme",
        "front-deltoids": "Schultern",
        "back-deltoids": "Hintere Deltas",
        "trapezius": "Trapez",
        "upper-back": "Rücken",
        "lower-back": "Unterer Rücken",
        "abs": "Rumpf",
        "obliques": "Rumpf",
        "quadriceps": "Quadrizeps",
        "hamstring": "Beinbeuger",
        "gluteal": "Gesäß",
        "adductors": "Adduktoren",
        "abductors": "Abduktoren",
        "calves": "Waden",
        "tibialis": "Schienbein",
        "neck": "Nacken",
        "head": "Kopf"
      }
    },
    "tabs": {
      "workouts": "Workouts",
      "plan": "Start",
      "progress": "Fortschritt",
      "catalog": "Katalog",
      "profile": "Profil",
      "settings": "Einstellungen",
      "inbox": "Eingang",
      "athletes": "Athleten",
      "me": "Ich"
    },
    "me": {
      "sectionTraining": "Training",
      "navTargets": "Ziele",
      "navTargetsSub": "Deine wöchentlichen Trainingsziele"
    },
    "settings": {
      "title": "Einstellungen",
      "exercisesSection": "Übungen",
      "navExercisesSub": "MAX, Katalog, Anstrengungsskala",
      "navCatalog": "Übungskatalog",
      "selectPrompt": "Wähle eine Einstellung, um sie zu öffnen.",
      "navCatalogSub": "Übungsbibliothek durchsuchen",
      "navEffort": "Anstrengungseinstellungen",
      "navEffortSub": "RIR / RPE Skala + Legende",
      "navLicenses": "Open-Source-Lizenzen",
      "navLicensesSub": "Bibliotheken, auf denen die App basiert",
      "sectionAccount": "Konto",
      "sectionTraining": "Training",
      "sectionBody": "Körper",
      "sectionPrefs": "Einstellungen",
      "sectionCoach": "Coach",
      "sectionAbout": "Über",
      "sectionHealthConnect": "Health Connect",
      "navHealthConnect": "Health Connect",
      "navHealthConnectSub": "Workouts & Gesundheitsdaten von deinem Gerät synchronisieren"
    },
    "energySource": {
      "zepp": "Zepp",
      "googleFit": "Google Fit",
      "healthConnect": "Health Connect",
      "jlEstimate": "JackedLogs",
      "pillLabel": "Kalorienquellen",
      "projectionNote": "Enthält den Satz, den du gleich machst: eine Hochrechnung der ganzen Einheit, nicht bereits erfasste Arbeit.",
      "selected": "ausgewählt"
    },
    "hc": {
      "preferences": "Präferenzen",
      "caloriesWins": "Health Connect zählt für Kalorien",
      "caloriesWinsHelp": "Wenn beide vorliegen, die in Health Connect gemessenen Kalorien statt der Schätzung von JackedLogs anzeigen. Aus = Schätzung bevorzugen. Ohne Health-Connect-Wert wird immer die Schätzung verwendet.",
      "title": "Health Connect",
      "intro": "Importiere die Aktivität von Uhr und Handy in JackedLogs. Spaziergänge, Wanderungen und Radtouren werden zu Workouts; Herzfrequenz und Kalorien ergänzen die Sessions, die du protokollierst. Aus, bis du verbindest.",
      "checking": "Prüfe…",
      "unavailable": "Health Connect ist auf diesem Gerät nicht verfügbar.",
      "updateRequired": "Aktualisiere die Health-Connect-App, um fortzufahren.",
      "notConnected": "Nicht verbunden.",
      "connect": "Health Connect verbinden",
      "connectHelp": "Du entscheidest, welche Daten JackedLogs lesen darf. Jederzeit in Health Connect änderbar.",
      "connected": "Verbunden",
      "reads": "Liest Workouts, Herzfrequenz und Kalorien.",
      "syncNow": "Jetzt synchronisieren",
      "neverSynced": "Noch nicht synchronisiert.",
      "lastSyncedAt": "Letzte Synchronisierung: {{when}}",
      "syncDelayNote": "Neue Aktivitäten brauchen manchmal ein paar Minuten, bis sie von deinem Gerät in Health Connect ankommen — ein kürzlicher Spaziergang oder eine Radtour erscheint womöglich erst bei einer späteren Synchronisierung. Diese Verzögerung ist normal.",
      "syncFullHistory": "Gesamten Verlauf synchronisieren",
      "syncingFullHistory": "Verlauf wird synchronisiert",
      "syncFullHistoryHelp": "Prüft deinen gesamten Verlauf erneut und füllt Lücken in Health Connect. Nutze das, wenn dort eine frühere Korrektur fehlt. Beliebig oft wiederholbar.",
      "resultSummary": "{{imported}} importiert · {{enriched}} ergänzt · {{skipped}} übersprungen",
      "error": "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
      "manageInHc": "In Health Connect verwalten",
      "disconnect": "Trennen",
      "disconnectTitle": "Health Connect trennen?",
      "disconnectBody": "JackedLogs liest deine Health-Connect-Daten dann nicht mehr. Bereits importierte Workouts bleiben in deinem Verlauf.",
      "logoA11y": "Health Connect",
      "privacyTitle": "Deine Daten",
      "privacyBody": "JackedLogs liest nur, was du in Health Connect erlaubst, und nur auf diesem Handy nach dem Verbinden. Sie liegen in deinem privaten JackedLogs-Konto, werden nie geteilt oder verkauft. Jederzeit trennbar, um zu stoppen.",
      "bodyResult": "{{imported}} Körperwerte importiert · {{skipped}} übersprungen",
      "bodyNotGranted": "Körperdaten noch nicht erlaubt. Tippe auf Körperdaten erlauben.",
      "readsFull": "Liest Workouts, Herzfrequenz und Kalorien, Gewicht und Körperzusammensetzung, Glukose und Ernährung. Schreibt Glukose zurück in Health Connect.",
      "backfillTitle": "Verlauf ab Mai importieren?",
      "backfillBody": "Durchsucht deinen Health-Connect-Verlauf bis Mai und importiert, was fehlt. Mehrfach ausführbar: bereits importierte Einträge werden übersprungen.",
      "backfillNow": "Verlauf importieren",
      "grantExtra": "Gesundheitsdaten erlauben",
      "extraGrantBody": "Importiere auch Gewicht, Körperzusammensetzung, Glukose und Ernährung.",
      "metabolicResult": "{{glucose}} Glukose · {{nutrition}} Ernährung importiert",
      "metabolicNotGranted": "Glukose und Ernährung noch nicht erlaubt.",
      "writeGlucoseGrantBody": "JackedLogs erlauben, Glukose in Health Connect zu schreiben.",
      "grantWrite": "Schreiben erlauben",
      "syncGlucoseToHc": "Glukose in Health Connect schreiben"
    },
    "metabolic": {
      "title": "Metabolisch",
      "loading": "Lädt…",
      "empty": "Verbinde Health Connect und synchronisiere, um hier Glukose und Ernährung zu sehen.",
      "glucoseEmpty": "Keine Glukosewerte",
      "glucoseLatest": "Letzte Glukose",
      "mgdl": "mg/dL",
      "targetBand": "Typischer Zielbereich {{lo}}–{{hi}} {{unit}}.",
      "carbsToday": "Kohlenhydrate heute",
      "grams": "g",
      "glucoseTitle": "Glukose",
      "glucoseCurrent": "Zuletzt: {{value}} {{unit}}",
      "glucoseNone": "Erfasse einen Wert, um deine Glukose zu verfolgen."
    },
    "exercisesScreen": {
      "back": "Zurück"
    },
    "body": {
      "back": "Zurück",
      "title": "Körper",
      "navTitle": "Körper",
      "navSub": "Geschlecht, Alter, Figur, Schmerzkarte",
      "trendsWebHint": "Körperzusammensetzungs-Diagramme sind in der mobilen App.",
      "sexLabel": "Geschlecht",
      "sexHelp": "Wird nur für die Körperfett-Schätzung verwendet. Die Figur der Muskelkarte ist eine separate Auswahl weiter unten.",
      "sex_male": "Mann",
      "sex_female": "Frau",
      "measurementsTitle": "Maße",
      "measurementsSub": "Gewicht, Umfänge, Körperfett-Schätzung",
      "measureTitle": "NEUE MESSUNG",
      "weight": "Gewicht",
      "field_heightCm": "Größe",
      "field_neckCm": "Hals",
      "field_chestCm": "Brust",
      "field_waistCm": "Taille",
      "field_hipsCm": "Hüfte",
      "field_bicepsLCm": "Bizeps (L)",
      "field_bicepsRCm": "Bizeps (R)",
      "field_forearmsLCm": "Unterarm (L)",
      "field_forearmsRCm": "Unterarm (R)",
      "field_thighsLCm": "Oberschenkel (L)",
      "field_thighsRCm": "Oberschenkel (R)",
      "field_calvesLCm": "Wade (L)",
      "field_calvesRCm": "Wade (R)",
      "measureSave": "Eingegebene Werte speichern",
      "measureHelpC": "Trage nur ein, was du gemessen hast. Leere Felder werden nicht gespeichert.",
      "useLastA11y": "Letzten Wert verwenden {{value}}",
      "saveFailedTitle": "Speichern fehlgeschlagen",
      "saveFailedBody": "Deine Messung wurde nicht gespeichert. Deine Werte bleiben erhalten — tippe zum erneuten Versuch auf Speichern.",
      "editTitle": "BEARBEITEN — {{date}}",
      "saveChanges": "Änderungen speichern",
      "editCancelA11y": "Bearbeiten abbrechen",
      "editRowA11y": "Messung {{date}} bearbeiten",
      "editHelp": "Ändere einen Wert oder lösche ihn, um ihn aus dem Verlauf zu entfernen.",
      "trendsLabel": "TRENDS",
      "trendsHint": "Werte wählen",
      "trendsExpandA11y": "Alle Werte anzeigen",
      "trendsCollapseA11y": "Werte einklappen",
      "trendsEmpty": "Erfasse mindestens 2 Messungen, um einen Trend zu sehen.",
      "metricComposition": "Zusammensetzung",
      "metricBodyFat": "Körperfett",
      "metricLeanMass": "Magermasse",
      "loadError": "Messungen konnten nicht geladen werden — prüfe deine Verbindung.",
      "queuedNote": "Warten auf Synchronisierung: {{count}}",
      "navyTitle": "KÖRPERZUSAMMENSETZUNG (NAVY)",
      "navyNeedsEntry": "Speichere unten eine Messung, um den Körperfettanteil zu schätzen.",
      "navyNeedsSex": "Lege oben dein Geschlecht fest, um den Körperfettanteil zu schätzen.",
      "navyNeedsInputs": "Füge Größe, Hals und Taille (und Hüfte für die weibliche Formel) hinzu, um den Körperfettanteil zu schätzen.",
      "navyBodyFat": "Körperfett ≈ {{pct}} %",
      "navyLeanMass": "Magermasse ≈ {{mass}}",
      "navyDisclaimer": "US-Navy-Schätzung (~±3,5 %). Achte auf den Trend, nicht auf den Einzelwert.",
      "historyEmpty": "Noch keine Messungen. Speichere oben eine, um mit dem Tracking zu beginnen.",
      "historyTitle": "VERLAUF",
      "trendWeight": "GEWICHTSVERLAUF",
      "trendBodyFat": "KÖRPERFETT-VERLAUF",
      "deleteTitle": "Messung löschen?",
      "deleteEmptyTitle": "Diese Messung entfernen?",
      "deleteEmptyBody": "Alle Werte sind gelöscht, daher wird der Eintrag entfernt.",
      "deleteCancel": "Abbrechen",
      "deleteConfirm": "Löschen",
      "ageLabel": "Alter",
      "ageHelp": "Optional. Zum Löschen erneut tippen.",
      "dualCurveLegend": "Durchgezogen: Schätzung · Gestrichelt: Health Connect",
      "bodyFatProvenance": "Der Körperfettanteil wird aus Taille und Hals berechnet.",
      "bodyFatProvenanceWithHips": "Der Körperfettanteil wird aus Taille, Hals und Hüfte berechnet."
    },
    "effortSettings": {
      "back": "Zurück",
      "title": "Anstrengung",
      "scaleLabel": "Anstrengungsskala",
      "scaleHelp": "Welche Skala der Logger verwendet. RIR = Wiederholungen in Reserve; RPE = empfundene Anstrengung. RPE = 10 − RIR, also dieselbe Anstrengung auf zwei Skalen."
    },
    "plan": {
      "currentBlockError": "Der aktuelle Block konnte nicht gesetzt werden. Bitte erneut versuchen.",
      "currentBlockOn": "Aktueller Block — zum Lösen tippen",
      "currentBlockOff": "Als aktuellen Block festlegen",
      "currentBlockHint": "Heftet die Wochenziele dieses Programms an den Home-Zähler",
      "title": "Plan",
      "start": "Starten",
      "starting": "Wird geöffnet…",
      "programWeekSession": "Woche {{week}}/{{cycle}} · {{session}}",
      "programLastCompleted": "Zuletzt: W{{week}} · {{session}}",
      "programNextHeader": "Als Nächstes",
      "programStartCta": "▶ {{session}} starten",
      "programChangeLink": "Woche oder Session ändern ›",
      "carouselPosition": "Programm {{n}} von {{total}}",
      "carouselPrev": "Vorheriges Programm",
      "carouselNext": "Nächstes Programm",
      "programWeekLabel": "Woche",
      "singleCycle": "Einzelzyklus, jede Woche gleich",
      "programSessionLabel": "Einheit",
      "programWeekShort": "W{{n}}",
      "programDayShort": "T{{n}}",
      "sessionN": "Einheit {{n}}",
      "sessionNShort": "E{{n}}",
      "programConfirm": "W{{week}} · {{session}} starten",
      "cancel": "Abbrechen",
      "newWorkout": "Neues Workout",
      "programsHint": "Mehrwöchige Zyklen, die automatisch fortschreiten, sobald Sie Trainings loggen.",
      "planDeleteTitle": "Plan löschen?",
      "programDeleteTitle": "Programm löschen?",
      "programStatusError": "Programm konnte nicht aktualisiert werden. Erneut versuchen.",
      "view": "Ansehen",
      "hide": "Ausblenden",
      "programUnfollowHint": "Diesem Programm nicht mehr folgen (bleibt in Meine Programme)",
      "programNextInline": "Nächste: W{{week}} · {{session}}",
      "programStartA11y": "{{session}} starten",
      "startPlanA11y": "{{name}} starten"
    },
    "preview": {
      "muscles": "Muskeln",
      "noSets": "Keine Sätze vorgesehen",
      "alternates": "Alternativen: {{names}}",
      "gridTitle": "Intensität · Tag × Woche",
      "gridHint": "Tippe auf einen Tag, um die Übungen zu sehen.",
      "matrixTitle": "Intensität · pro Satz",
      "matrixHint": "Tippe auf eine Übung, um ihre Sätze zu sehen.",
      "restDay": "Ruhe / leicht",
      "intensity": {
        "work": "Arbeit",
        "moderate": "moderat",
        "heavy": "schwer",
        "max": "Max",
        "free": "frei"
      }
    },
    "catalog": {
      "title": "Katalog",
      "search": "Übungen suchen",
      "empty": "Keine passende Übung.",
      "back": "Zurück",
      "notFound": "Übung nicht gefunden.",
      "metaPrimaryMuscle": "Hauptmuskel",
      "metaPattern": "Pattern",
      "metaEquipment": "Ausrüstung",
      "metaP1RM": "Programmierbar",
      "metaP1RMYes": "Ja",
      "metaP1RMNo": "Nein",
      "metaDefaultBar": "Standard-Hantel",
      "metaBarLoading": "Hantelbeladung",
      "metaBarLoadingLandmine": "Landmine (einseitig)",
      "aliasesLabel": "Auch bekannt als",
      "tagsLabel": "Tags",
      "historyLabel": "Aktuelle Trainings",
      "historyEmpty": "Keine vergangenen Trainings für diese Übung.",
      "historyError": "Verlauf konnte nicht geladen werden.",
      "historyBodyweight": "{{reps}} Wdh. KG",
      "recordsLabel": "Rekorde",
      "recordsEmpty": "Noch keine Rekorde.",
      "selectPrompt": "Wähle eine Übung, um ihre Details zu sehen.",
      "recordsError": "Rekorde konnten nicht geladen werden.",
      "refreshing": "Wird aktualisiert…"
    },
    "maxes": {
      "title": "MAX",
      "back": "Zurück",
      "search": "Übungen suchen",
      "empty": "Keine passende Übung.",
      "editCancel": "Abbrechen",
      "editSave": "Speichern",
      "errInvalid": "Bitte ein gültiges Gewicht eingeben.",
      "clearAction": "MAX entfernen",
      "clearTitle": "Diesen MAX entfernen?",
      "clearBody": "Wert und Verlauf bleiben auf dem Server erhalten, aber der MAX gilt als nicht gesetzt.",
      "clearCancel": "Abbrechen",
      "clearConfirm": "Entfernen",
      "selectPrompt": "Wähle eine Übung, um ihr MAX festzulegen.",
      "unitChipLabel": "Gewichtseinheit: {{unit}}",
      "unitKg": "Kilogramm",
      "unitLb": "Pfund",
      "unitChipHint": "Wechselt die Einheit und rechnet den Wert um"
    },
    "login": {
      "title": "JackedLogs",
      "subtitle": "Bei deinem Konto anmelden",
      "submit": "Anmelden"
    },
    "workouts": {
      "title": "Workouts",
      "empty": "Noch keine Workouts erfasst.",
      "fallbackName": "Workout",
      "endOfList_one": "{{count}} Session, Ende der Liste.",
      "endOfList_other": "{{count}} Sessions, Ende der Liste.",
      "newButton": "Neu",
      "queuedBanner_one": "{{count}} Workout in der Warteschlange. Tippen für erneuten Versuch.",
      "queuedBanner_other": "{{count}} Workouts in der Warteschlange. Tippen für erneuten Versuch.",
      "maxQueuedBanner_one": "{{count}} MAX in der Warteschlange. Wird automatisch gesendet, sobald du wieder online bist.",
      "maxQueuedBanner_other": "{{count}} MAX in der Warteschlange. Werden automatisch gesendet, sobald du wieder online bist.",
      "maxQueuedHint": "Tippen, um jetzt zu synchronisieren.",
      "maxConfirmFailedTitle": "MAX nicht gespeichert",
      "maxConfirmFailedBody": "Der Server hat diesen Wert nicht akzeptiert, es wurde nichts geschrieben. Dein MAX bleibt unverändert. Du kannst ihn unter Ich, Maxima von Hand setzen.",
      "queuedRetry": "Wiederholen",
      "queuedDetail": "Details",
      "queuedHint": "Tippen, um es jetzt zu versuchen, lange drücken zum Verwerfen.",
      "queuedHintDetail": "Tippen, um die Warteschlange zu sehen, lange drücken zum Verwerfen.",
      "queueDismissTitle": "Wartende Workouts verwerfen?",
      "queueDismissBody_one": "{{count}} Workout wird entfernt und nicht gespeichert.",
      "queueDismissBody_other": "{{count}} Workouts werden entfernt und nicht gespeichert.",
      "queueDismissCancel": "Abbrechen",
      "queueDismissConfirm": "Verwerfen",
      "editUnsupportedTitle": "Bearbeiten auf Mobil noch nicht unterstützt",
      "editUnsupportedBody": "Dieses Workout enthält Übungstypen (P1RM, Loaded Carry), die der mobile Logger noch nicht bearbeiten kann. Öffne es in der Web-App.",
      "editUnsupportedAck": "OK",
      "maxBumpHeader_one": "{{count}} neuer MAX",
      "maxBumpHeader_other": "{{count}} neue MAX-Werte",
      "maxBumpRow": "{{exercise}}: {{valueKg}} kg",
      "maxBumpConfirm": "Bestätigen",
      "maxBumpDismiss": "Überspringen",
      "repeat": "Workout wiederholen",
      "resumePillAction": "Fortsetzen",
      "resumePillFallback": "Workout läuft",
      "cancel": "Abbrechen",
      "loadOlder": "Ältere Monate laden",
      "selectPrompt": "Wähle ein Workout, um die Zusammenfassung zu sehen.",
      "loadError": "Diese Sitzung konnte nicht geladen werden.",
      "maxDropRow": "{{exercise}}: MAX ist evtl. auf {{valueKg}} kg gesunken (war {{currentKg}}, vor {{weeks}} Wo.)",
      "maxDropConfirm": "Senken auf {{valueKg}}",
      "maxDropKeep": "{{valueKg}} behalten",
      "maxDropBadDay": "Schlechter Tag",
      "importedBadge": "Importiert"
    },
    "outboxDetail": {
      "title": "Workouts in Warteschlange",
      "close": "Schließen",
      "empty": "Nichts in der Warteschlange.",
      "statusQueued": "In Warteschlange",
      "statusSending": "Wird gesendet",
      "statusFailed4xx": "Vom Server abgelehnt",
      "statusPermanentFail": "Aufgegeben",
      "attempts_one": "{{count}} Versuch",
      "attempts_other": "{{count}} Versuche",
      "dismissOne": "Verwerfen",
      "dismissOneTitle": "Dieses Workout verwerfen?",
      "dismissOneBody": "Das Workout vom {{date}} wird ohne Speichern entfernt.",
      "dismissCancel": "Abbrechen",
      "dismissConfirm": "Verwerfen",
      "retryAll": "Alle wiederholen",
      "dismissAll": "Alle verwerfen",
      "queueWorkout": "Training",
      "queueWorkoutNote": "Trainingsnotiz",
      "queueMeasurement": "Messung",
      "queueMax": "Maximum",
      "queueProfile": "Profil",
      "queueHealth": "Gesundheitsdaten",
      "queueMetabolic": "Stoffwechseldaten",
      "queueRequest": "Änderung",
      "stuckTitle": "Nicht durchgegangene Speicherungen"
    },
    "stuckWrites": {
      "banner_one": "{{count}} Speicherung ist nicht durchgegangen",
      "banner_other": "{{count}} Speicherungen sind nicht durchgegangen",
      "retry": "Erneut versuchen",
      "retrying": "Neuer Versuch…",
      "details": "Details"
    },
    "progress": {
      "title": "Fortschritt",
      "windowAll": "Letzte Sessions",
      "window30d": "Letzte 30 Tage",
      "window7d": "Letzte 7 Tage",
      "lastSession": "Letzte Session",
      "frequencyTitle": "Wochenfrequenz",
      "frequencyHelp": "Sessions pro Woche, letzte {{weeks}} Wochen (aktuelle Woche rechts).",
      "recordsTitle": "Rekorde",
      "recordsHelp": "Beste Wiederholungs-Records pro Übung. Neueste zuerst.",
      "recordsAllTime": "Gesamt",
      "recordsThisYear": "{{year}}",
      "recordsSearch": "Nach Übung filtern",
      "recordsNoMatch": "Keine Übung passt zum Filter.",
      "tagVolumeTitle": "Volumen nach Tag",
      "tagVolumeHelp": "Trainingsvolumen pro Muskel/Tag im jüngsten Zeitraum.",
      "recordsEmpty": "Noch keine Rekorde — logge ein paar Sätze, um die Liste zu füllen.",
      "chartE1rm": "Geschätztes 1RM",
      "chartVolume": "Volumen",
      "chartScope": "Basierend auf den letzten {{n}} Sitzungen.",
      "chartLoadFailed": "Diagramm konnte nicht geladen werden.",
      "chartEmpty": "Keine gewichteten Sätze im jüngsten Zeitfenster.",
      "viewByExercise": "Nach Übung",
      "viewByTag": "Nach Tag",
      "noTags": "Keine Übungen mit Tags im jüngsten Zeitfenster.",
      "totalVolume": "Gesamt: {{weight}}",
      "chartMax": "MAX (kg)",
      "chartEstimatedBadge": "mit e1RM-Überlagerung",
      "prFound": "Rekord erkannt: {{weight}}",
      "prUpdate": "MAX auf {{weight}} aktualisieren",
      "prUpdating": "Aktualisiere…",
      "painSeverity": {
        "red": "rot",
        "yellow": "gelb",
        "green": "grün"
      },
      "balance": {
        "title": "Bewegungsbalance",
        "help": "Sätze und Volumen pro Bewegungsmuster über den ausgewählten Zeitraum von {{days}} Tagen, sortiert nach Sätzen. Die kleine Zahl „X/7T“ zeigt die Anzahl der letzten 7 Tage und hilft, eine einzelne kürzliche Belastungsspitze (oder eine bewusste Reduktion) zu erkennen, die der längere Zeitraum verbirgt."
      },
      "empty": "Keine aktuelle Aktivität zum Vergleich",
      "pain": {
        "title": "Schmerz × Volumen",
        "help": "Für jeden aktuell im painMap markierten Muskel wird die jüngste Trainingsbelastung angezeigt. Roter Punkt = Schmerz als rot gemeldet (schwere Belastung vermeiden), gelb = Vorsicht, grün = beobachten. Die beiden Volumenwerte sind die Belastung der letzten 7 Tage bzw. des ausgewählten Zeitraums von {{days}} Tagen auf diesen Muskel — anhaltend hohe Belastung auf einem roten Muskel ist das risikoreichste Signal im Dashboard.",
        "noPain": "Keine Muskeln im painMap markiert",
        "sevRed": "Vermeiden",
        "sevYellow": "Vorsicht",
        "sevGreen": "Beobachten"
      },
      "trends": {
        "a11yUp": "Fortschritt",
        "a11yFlat": "Plateau",
        "a11yDown": "Rückgang",
        "title": "E1RM-Trends",
        "help": "Für jedes Bewegungsmuster (Kniebeuge, Hüftbeugung, Drücken, Ziehen, …) wird die Übung mit Ihrem höchsten e1RM angezeigt. Diagramm = e1RM-Werte im ausgewählten Zeitraum von {{days}} Tagen (für den Wert auf einen Punkt tippen). Pfeil = Trend über diesen Zeitraum: ↗ Fortschritt, → Plateau, ↘ Rückgang. Das Hinweisfeld „Wenige Daten“ erscheint, wenn weniger als 3 Punkte für eine Trendlinie vorliegen.",
        "fewData": "Wenige Datenpunkte in {{days}} T",
        "notMeasurable": "Noch nicht messbar: kein {{name}}-Satz ging nahe ans Limit. Ein bis nahe ans Muskelversagen geführter Satz (ein AMRAP) würde Ihre Kraft hier zeigen.",
        "machineNotMeasurable": "{{value}}, noch nicht messbar",
        "machineMore": "{{machine}} · +{{count}}",
        "machineA11y_one": "{{exercise}}, {{machine}}. Die andere Maschine anzeigen.",
        "machineA11y_other": "{{exercise}}, {{machine}}. Die {{count}} anderen Maschinen anzeigen.",
        "machineSessions_one": "{{count}} Einheit",
        "machineSessions_other": "{{count}} Einheiten"
      },
      "repsAtLoad": {
        "a11yUp": "steigend",
        "a11yFlat": "stabil",
        "a11yDown": "fallend",
        "title": "Wiederholungen bei festem Gewicht",
        "help": "Für Übungen, bei denen Sie dasselbe Gewicht wiederholen, zeigt dies die Wiederholungen bei diesem festen Gewicht im ausgewählten Zeitraum von {{days}} Tagen — der Kraftzuwachs, den das e1RM-Diagramm bei hohen Wiederholungszahlen und an Maschinen nicht sieht. Diagramm = Wiederholungen beim Gewicht über die Zeit (auf einen Punkt tippen). Pfeil = Trend: ↗ steigend, → stabil, ↘ fallend. Nur Sätze mit erfasster Anstrengung zählen, damit mehr Wiederholungen nicht einfach nur ein leichterer Tag sein können.",
        "repsValue": "{{reps}} × {{load}}",
        "fewData": "Wenige Datenpunkte in {{days}} T",
        "notMeasurable": "Noch nicht messbar: Ihre {{name}}-Sätze bei {{load}} haben keine erfasste Anstrengung, daher könnten mehr Wiederholungen einfach nur ein leichterer Tag sein. Ein bis nahe ans Muskelversagen geführter Satz — oder eine erfasste Anstrengung — würde hier Ihre Kraft zeigen."
      },
      "period": {
        "all": "gesamt"
      },
      "loadFailed": "Laden fehlgeschlagen",
      "density": {
        "title": "Dichte",
        "help": "Volumen geteilt durch Trainingsdauer, kg/min. Liest sich als „wie dicht war diese Einheit“ — ein Anstieg bedeutet, dass Sie dieselbe Last in weniger Zeit bewältigen (bessere Kondition) oder mehr Last in derselben Zeit (mehr Kraft). Ein plötzlicher Rückgang ohne Programmänderung deutet häufig auf Ermüdung hin: Die Pausen haben sich verlängert, auch wenn dies nicht geplant war.",
        "empty": "Mindestens 3 zeitgemessene Einheiten erforderlich, um die Dichte darzustellen"
      },
      "frequency": {
        "title": "Vernachlässigte Übungen",
        "help": "Top 8 Übungen, sortiert nach Tagen seit der letzten Protokollierung, am stärksten vernachlässigte zuerst. Das Suffix X/{{days}}T zeigt die Anzahl der Sätze im ausgewählten Zeitraum. Zahlen in Rot = seit 14+ Tagen unberührt: Entweder wurde die Übung bewusst gestrichen, oder das Programm ist abgedriftet. Nützlich, um Zusatzarbeit zu identifizieren, die unbemerkt verschwunden ist.",
        "today": "heute",
        "daysAgo": "vor {{n}} T"
      },
      "fatigueDrift": {
        "title": "Ermüdungsdrift (RIR)",
        "help": "Gleitender Wochendurchschnitt von RPE und verbleibenden Wiederholungen für Sätze, in denen beide erfasst sind. Steigender RPE bei fallendem RIR auf ähnlichen Lasten = akkumulierte Ermüdung, die sichtbar wird, bevor die Hantel langsamer wird. Eine Entlastungswoche oder ein Deload löst das in der Regel.",
        "noData": "Erfasse RPE und RIR auf einigen Sätzen, um die Ermüdungsdrift zu visualisieren",
        "rising": "Steigende Ermüdung",
        "stable": "Stabil",
        "legend": "RPE (links) · RIR (rechts) — für Werte auf eine Woche tippen"
      },
      "intensityHeatmap": {
        "title": "Intensitäts-Heatmap",
        "help": "Pro-Übung-Raster der absolvierten Sätze, sortiert nach Wiederholungsbereich und Intensität (% des 1RM). Kraftbereich (85%+) unten rechts, Hypertrophie in der Mitte, Ausdauer oben links. Wähle eine Übung, um zu sehen, wo sich ihre Sätze ballen.",
        "exerciseLabel": "Übung",
        "choosePrompt": "Übung wählen",
        "noEligible": "Hinterlege ein 1RM für mindestens eine Übung, damit die Intensität berechnet werden kann.",
        "noMax": "Für diese Übung ist noch kein 1RM erfasst.",
        "totalSets": "{{n}} Sätze · 1RM {{max}}",
        "clear": "Keine"
      },
      "a11y": {
        "severityAlarm": "Alarm",
        "severityWarn": "Warnung",
        "severityInfo": "Info",
        "stale": "Inaktiv"
      }
    },
    "profile": {
      "title": "Profil",
      "navMaxes": "MAX",
      "navMaxesSub": "MAX je Übung setzen, bearbeiten und überprüfen.",
      "navCatalogSub": "Übungen, Rekorde und Verlauf durchsuchen.",
      "navRestTimer": "Timer",
      "navRestTimerSub": "Pausen- + Halte-Standards, Ton, pro Übung",
      "labelEmail": "E-MAIL",
      "labelApp": "APP-VERSION",
      "labelBackend": "BACKEND-VERSION",
      "labelPrivacy": "DATENSCHUTZ",
      "privacyHelp": "Alles als JSON exportieren oder das Konto endgültig löschen.",
      "exportButton": "Meine Daten exportieren",
      "deleteButton": "Mein Konto löschen",
      "deleteAlertTitle": "Konto löschen",
      "deleteAlertBody": "Dein Konto, deine Sessions, Pläne, Programme und MAX-Werte werden endgültig gelöscht. Löschungen sind nicht rückgängig zu machen.",
      "deleteAlertCancel": "Abbrechen",
      "deleteAlertConfirm": "Löschen",
      "signOut": "Abmelden",
      "exportShareTitle": "JackedLogs-Export {{date}}",
      "labelLanguage": "Sprache",
      "languageHelp": "Wähle die Sprache der App. Auf diesem Gerät gespeichert.",
      "languageCancel": "Schließen"
    },
    "summary": {
      "prBadge": "persönlicher Rekord"
    },
    "logger": {
      "title": "Neues Workout",
      "cancel": "Abbrechen",
      "swapKindTitle": "Übungstyp ändern?",
      "swapKindBody": "Diese Übung wird anders erfasst, daher werden die hier bereits erfassten Sätze gelöscht.",
      "swapKindConfirm": "Ändern & löschen",
      "failConfirmTitle": "Gültige Reps",
      "failConfirmBody_one": "Ich speichere {{count}} saubere Wiederholung. Die fehlgeschlagene zählt nicht.",
      "failConfirmBody_other": "Ich speichere {{count}} saubere Wiederholungen. Die fehlgeschlagene zählt nicht.",
      "failConfirmHint": "Passe an, wenn du mehr oder weniger gemacht hast.",
      "failConfirmStepDown": "Eine saubere Wiederholung weniger",
      "failConfirmStepUp": "Eine saubere Wiederholung mehr",
      "failConfirmSave": "Speichern",
      "amrapConfirmTitle": "Bis zum Muskelversagen?",
      "amrapConfirmBody": "Antworte nur dann mit Ja, wenn die nächste Wiederholung nicht mehr gekommen wäre.",
      "amrapNeedsReps": "Trag die Wiederholungen ein, die du geschafft hast, um den Satz zu speichern.",
      "amrapBadgeWithFloor": "AMRAP ≥ {{reps}}",
      "amrapPrescribedFloorA11y": "AMRAP: mindestens {{reps}} Wiederholungen, dann so viele wie möglich",
      "amrapConfirmAtFloor": "Du hast {{reps}} eingetragen, das Programm verlangte mindestens {{floor}}.",
      "amrapFloorPlaceholder": "≥ {{reps}}",
      "amrapConfirmYes": "Ja, bis zum Versagen",
      "amrapConfirmNo": "Nein, da war noch was",
      "failBadge": "Gescheitert",
      "failBadgeA11y": "fehlgeschlagener Satz",
      "save": "Speichern",
      "remove": "Entfernen",
      "replace": "Ersetzen",
      "addExercise": "Übung hinzufügen",
      "addSet": "Satz hinzufügen",
      "addRound": "Runde hinzufügen",
      "pickerTitle": "Übung wählen",
      "pickerSearch": "Übungen suchen",
      "pickerEmpty": "Keine Übung gefunden.",
      "pickerClearFilters": "Filter löschen",
      "pickerFilters": "Filter",
      "pickerFiltersN": "Filter ({{n}})",
      "empty": "Noch keine Übung. Füge eine hinzu, um loszulegen.",
      "setReps": "WDH",
      "amrapPrescribedA11y": "AMRAP: mindestens die vorgegebenen Wiederholungen, dann so viele wie möglich",
      "setWeight": "KG",
      "setWeightLb": "LB",
      "setWeightBothSidesA11y": "Gewicht einer Seite, beide Seiten gezählt ({{unit}})",
      "setTypeWorking": "Normal",
      "setTypeDropset": "Dropset",
      "setTypeMyorep": "Myo-Rep",
      "setCommentLabel": "Satz-Kommentar",
      "unitLabel": "Einheit",
      "discardTitle": "Workout verwerfen?",
      "discardBody": "Die bisher erfassten Sätze gehen verloren.",
      "discardCancel": "Weiter",
      "discardConfirm": "Verwerfen",
      "errNoEntries": "Füge mindestens eine Übung hinzu.",
      "errNoSets": "Jede Übung braucht mindestens einen Satz mit Wdh und Gewicht.",
      "errInvalid": "Das Workout lässt sich so nicht speichern.",
      "errSaveFailed": "Speichern fehlgeschlagen. Tippe im Warteschlangen-Banner auf Wiederholen, sobald du online bist.",
      "setNumberHeader": "SATZ",
      "removeSetA11y": "Diesen Satz entfernen",
      "serverErrorTitle": "SERVER HAT DAS SPEICHERN ABGELEHNT",
      "serverErrorHint": "Passe das Workout an und versuche es erneut. Bei unklaren Meldungen teile sie mit deinem Coach.",
      "setExtra": "EXTRA",
      "bwPromptTitle": "Körpergewicht eintragen",
      "bwPromptBody": "Eigengewichtsübungen brauchen dein Gewicht, um Last und Volumen zu berechnen. Trage es unter Einstellungen → Körper ein.",
      "bwPromptCta": "Eintragen",
      "setWeightTip": "Last pro Satz. Mit dem Einheiten-Chip je Zeile zwischen kg/lb wechseln.",
      "setExtraTip": "Unterstützung oder Zusatzlast beim Eigengewicht. Tippe ein Minus (−) für Band-/Maschinenhilfe (das Feld wird bernsteinfarben); Gürtel/Scheibe ist positiv.",
      "setWeightMixedTip": "Gemischte Gruppe: Hantel-/Stack-Last in Gewichtszeilen, ± Extra in Eigengewichtszeilen (Minus = Hilfe).",
      "editTitle": "Workout bearbeiten",
      "repeatTitle": "Workout wiederholen",
      "minimize": "Workout minimieren",
      "closeWorkout": "Workout schließen",
      "saveWorkout": "Workout speichern",
      "bilateral": "Bilateral",
      "unilateral": "Unilateral",
      "plates": "Scheiben",
      "numInvalid": "Ungültige Zahl",
      "numRange": "{{label}} {{min}}–{{max}}",
      "setRpeHint": "Anstrengung 1–10",
      "setNoteLabel": "Notiz",
      "setNotePlaceholder": "Cue, Technik, Empfinden…",
      "elapsedA11y": "Vergangene Zeit",
      "totalsSets_one": "{{count}} Satz",
      "totalsSets_other": "{{count}} Sätze",
      "totalsReps_one": "{{count}} Wdh.",
      "totalsReps_other": "{{count}} Wdh.",
      "totalsTitle": "Workout-Summe",
      "totalsVolume": "Volumen",
      "totalsSetsShort": "Sätze",
      "totalsRepsShort": "Wdh.",
      "totalsByMuscle": "Belastung pro Muskel",
      "restRest": "Pause",
      "startRestManual": "Pause starten",
      "restSkip": "Überspringen",
      "restWord": "Pause",
      "restAddStep": "+{{n}} Sekunden",
      "restSubtractStep": "−{{n}} Sekunden",
      "restRemainingA11y": "{{time}} Pause übrig",
      "restLockedA11y": "Bearbeitung während der Pause gesperrt. Zum Bearbeiten auf „Überspringen“ tippen.",
      "restEditA11y": "Standardpause für diese Übung festlegen",
      "restEditTitle": "Standardpause",
      "restEditBody": "Diese Pause als Standard für {{name}} speichern",
      "restEditSave": "Speichern",
      "restEditSaving": "Wird gespeichert…",
      "restEditError": "Standardpause konnte nicht gespeichert werden. Erneut versuchen.",
      "restEditCancel": "Abbrechen",
      "restEditSaveAsGlobal": "Als globalen Standard verwenden",
      "restStepMinus": "Um {{step}} Sekunden verringern",
      "restStepPlus": "Um {{step}} Sekunden erhöhen",
      "restPause": "Anhalten",
      "restResume": "Fortsetzen",
      "restExpiredTitle": "Pause vorbei",
      "holdExpiredTitle": "Zeit um",
      "restExpiredBody": "Weiter geht's.",
      "holdExpiredBody": "Tippe auf das Belastungsband, um den Satz zu speichern.",
      "boutExpiredTitle": "Intervall beendet",
      "boutExpiredBody": "Satz automatisch gespeichert.",
      "boutAutoLoggedA11y": "Intervall beendet, {{time}} gespeichert.",
      "workoutFgsTitle": "Training läuft",
      "workoutFgsBodyNamed": "{{name}} · zum Fortsetzen tippen",
      "workoutFgsBody": "Zum Fortsetzen tippen",
      "descriptionToggle": "Beschreibung ein-/ausblenden",
      "notesToggle": "Coach-Notizen für dieses Training",
      "notesProgramLabel": "Programm",
      "notesWorkoutLabel": "Dieses Training",
      "note": "Notiz",
      "rpeChip": "RPE",
      "historyChip": "Verlauf",
      "more": "Weitere Aktionen",
      "addGroup": "Mit einer anderen Übung gruppieren",
      "cardioDuration": "Dauer",
      "cardioDurationPlaceholder": "Sekunden",
      "cardioDistance": "Distanz",
      "cardioWeight": "Gewicht",
      "cardioHr": "Ø Puls",
      "cardioCalories": "Kalorien",
      "cardioOptionalsShow": "Weitere Felder anzeigen",
      "cardioOptionalsHide": "Weitere Felder ausblenden",
      "dateEditor": "Datum & Dauer",
      "dateLabel": "Datum",
      "startTimeLabel": "Start",
      "endTimeLabel": "Ende",
      "durationLabel": "Dauer",
      "historyToggle": "Verlauf",
      "historyCount_one": "{{count}} Einheit",
      "historyCount_other": "{{count}} Einheiten",
      "historyBest": "Beste",
      "historyCopy": "Kopieren",
      "historyBodyweight": "{{reps}} Wdh. KG",
      "historyEstimateHeader": "Schätzung aus einer ähnlichen Übung",
      "historyEstimatedFrom": "Von {{name}}",
      "historyNoEstimate": "Noch kein Verlauf und keine ähnliche Übung zum Schätzen.",
      "copyDialogTitle": "Einheit kopieren",
      "copyDialogBody": "Offene Sätze ersetzen oder zu den bestehenden hinzufügen?",
      "copyOverwrite": "Ersetzen",
      "copyAppend": "Hinzufügen",
      "resumeTitle": "Training fortsetzen?",
      "resumeBody": "Sie haben am {{date}} ein Training begonnen, das nicht gespeichert wurde. Fortsetzen oder verwerfen?",
      "resumeContinue": "Fortsetzen",
      "resumeDiscard": "Verwerfen",
      "conflictTitle": "Training läuft",
      "conflictBody": "Sie protokollieren bereits ein Training. Weiter oder anzeigen, um es zu speichern oder zu verwerfen.",
      "nameLabel": "Workout-Name",
      "namePlaceholder": "Name: z. B. Push…",
      "editNameA11y": "Workout-Namen bearbeiten",
      "setStateA11y": "Satz {{index}} {{state}}",
      "rpePlaceholder": "RPE",
      "unitA11y": "Einheit {{unit}}",
      "stepperPositive": "hinzufügen",
      "stepperNegative": "abziehen",
      "historyCount": "{{n}} Einheiten",
      "rirPlaceholder": "RIR",
      "effortMeterEasy": "Leicht",
      "effortMeterHard": "Schwer",
      "effortWord": "Belastung",
      "holdSlotDone": "FERTIG",
      "holdSlotHeld": "GEHALTEN",
      "holdSlotDoneA11y": "{{time}} erledigt",
      "holdSlotFailedA11y": "{{time}}, nicht geschafft",
      "holdSlotHeldA11y": "{{time}} gehalten",
      "effortMeterFail": "Fail",
      "effortMeterTargetWord": "Ziel",
      "effortQuestionRir": "Reps in Reserve?",
      "effortQuestionRpe": "Wie hart war es?",
      "effortQuestionHint": "Öffnet die Anstrengungsskala — wie sie funktioniert und wie man sie wechselt",
      "effortMeterHintLog": "Protokolliert den Satz auch als abgeschlossen",
      "effortMeterHintRunning": "Stoppt den Timer und speichert den Satz",
      "effortMeterHintEdit": "Aktualisiert die Anstrengung dieses Satzes",
      "effortMeterFailHintLog": "Protokolliert den Satz als gescheitert",
      "effortMeterFailHintEdit": "Wechselt den Satz zwischen abgeschlossen und gescheitert",
      "effortMeterTapCta": "Zum Speichern des Satzes tippen",
      "effortMeterStopCta": "Tippen zum Stoppen und Speichern",
      "effortNudgeOptOut": "Erinnerung deaktivieren",
      "effortNudgeOptOutHint": "Fragt vorher nach. Du kannst es in den Einstellungen wieder einschalten.",
      "effortNudgeOptOutConfirmTitle": "Diese Erinnerung deaktivieren?",
      "effortNudgeOptOutConfirmBody": "Jederzeit in den Einstellungen wieder aktivierbar.",
      "effortNudgeOptOutConfirmButton": "Deaktivieren",
      "effortMeterAmrapDone": "Fertig",
      "effortMeterAmrapHint": "Speichert den Satz bis zum Muskelversagen — keine Wiederholung übrig",
      "amrapChip": "So viele Wiederholungen wie möglich",
      "burnPlus": "Burn+",
      "burnPlusChip": "Burn+ Intensitätstechnik (Dropset / Myo-Rep)",
      "effortLegendA11y": "Hilfe zur Anstrengungsskala",
      "rirLegendTitle": "RIR: Wiederholungen in Reserve",
      "rirLegendBody": "0 = keine Wiederholung übrig\n1 = 1 Wiederholung übrig\n2 = 2 Wiederholungen\n3 = guter Spielraum\n4+ = leicht / Aufwärmen",
      "rpeLegendTitle": "RPE: empfundene Anstrengung",
      "rpeLegendBody": "10 = keine Wiederholung übrig\n9 = 1 Wiederholung übrig\n8 = 2 Wiederholungen\n7 = guter Spielraum\n6 oder weniger = leicht / Aufwärmen",
      "timerStartCountdown": "Countdown starten",
      "timerStartCountup": "Stoppuhr starten",
      "timerSettings": "Timer-Standard für diese Übung",
      "holdHeaderHours": "Std",
      "holdHeaderMinutes": "Min",
      "holdHeaderSeconds": "Sek",
      "holdHours": "Stunden",
      "holdMinutes": "Minuten",
      "holdSeconds": "Sekunden",
      "holdSubTen": "-10 Sek.",
      "holdAddTen": "+10 Sek.",
      "holdCancel": "Abbrechen",
      "holdClockElapsedA11y": "{{time}} vergangen",
      "holdClockOvertimeA11y": "{{time}} über dem Ziel",
      "holdClockPausedA11y": "{{label}}, pausiert",
      "holdClockRemainingA11y": "noch {{time}}",
      "holdFlip": "Richtung wechseln",
      "holdExtraWeight": "Zusatz",
      "lateralityTipUni": "UNI · eine Seite erfassen; Volumen zählt beide (×2).",
      "lateralityTipBi": "BI · bilaterale Last; Volumen zählt einmal (×1).",
      "tabExercises": "Übungen",
      "tabSuperset": "Supersatz",
      "pickerAddN": "{{n}} hinzufügen",
      "pickerAlreadyInWorkout": "Schon in diesem Workout",
      "pickerAlreadyInBlock": "Schon in diesem Block",
      "pickerPin": "Zu Favoriten",
      "pickerUnpin": "Aus Favoriten entfernen",
      "noteReadA11y": "Übungsnotiz — antippen, um alles zu lesen",
      "prescriptionReadA11y": "Satzvorgabe — antippen, um alles zu lesen",
      "helpToggle": "Hilfe — tippe auf einen Chip, um zu sehen, was er macht",
      "tipAmrap": "So viele Wiederholungen wie möglich — führe diesen Satz bis zum technischen Versagen.",
      "tipBurnPlus": "Intensitätstechniken — blende Dropset oder Myo-rep ein, um den Satz über das Versagen hinaus zu treiben.",
      "helpBanner": "Hilfemodus — tippe auf einen Chip, um zu sehen, was er macht; tippe auf ⓘ zum Beenden.",
      "helpModeHint": "Hilfemodus aktiv — dies erklärt, statt die Einstellung zu ändern.",
      "targetsMore": "+{{count}} weitere",
      "targetEyebrow": "Ziel"
    },
    "coachBanner": {
      "a11y": "{{count}} Coach-Einladungen warten",
      "one": "1 Coach-Einladung wartet",
      "many": "{{count}} Coach-Einladungen warten",
      "action": "Öffnen"
    },
    "coachEdges": {
      "empty": "Noch keine Coach-Verbindungen. Ein Coach kann Sie aus der Web-App einladen."
    },
    "toxicDraft": {
      "banner": "Beschädigtes Training wiederhergestellt.",
      "viewJson": "JSON anzeigen",
      "sendSupport": "An den Support senden",
      "dismiss": "Verwerfen",
      "close": "Schließen",
      "jsonTitle": "Training in Quarantäne",
      "supportPrefix": "Beschädigter Entwurf automatisch durch den Boot-Versuchszähler erkannt. JSON in Quarantäne unten.",
      "sentTitle": "An den Support senden",
      "sentBody": "Wiederherstellungsdaten gesendet.",
      "sendError": "Senden fehlgeschlagen. Das Training bleibt in Quarantäne."
    },
    "recovery": {
      "banner": "Wiederhergestelltes Workout",
      "summary": "{{date}} · {{exercises}} Übungen · {{done}}/{{total}} Sätze erledigt",
      "saveAsNew": "Als neu speichern",
      "discard": "Verwerfen",
      "title": "Wiederhergestelltes Workout",
      "openBody": "Dieses Workout wurde unterbrochen und wiederhergestellt. Prüfe die Sätze und tippe auf Speichern, um es als neues Workout zu sichern.",
      "open": "Öffnen",
      "cancel": "Abbrechen",
      "liveBusy": "Du hast ein laufendes Workout. Speichere oder verwirf es, bevor du dieses wiederherstellst.",
      "discardTitle": "Wiederhergestelltes Workout verwerfen?",
      "discardBody": "Das wiederhergestellte Workout wird dauerhaft gelöscht.",
      "discardConfirm": "Verwerfen",
      "error": "Workout konnte nicht wiederhergestellt werden. Versuche es erneut.",
      "merge": "Zusammenführen…",
      "mergeTitle": "Workout zusammenführen",
      "mergePrompt": "Wähle ein Workout vom selben Tag zum Zusammenführen:",
      "noSameDay": "Kein Workout vom selben Tag zum Zusammenführen. Nutze „Als neu speichern\".",
      "nothingToMerge": "Keine abgeschlossenen Sätze zum Zusammenführen. Nutze „Als neu speichern\"."
    },
    "group": {
      "title": "Übung gruppieren",
      "close": "Schließen",
      "standalone": "Einzeln",
      "supersetSection": "SUPERSÄTZE",
      "circuitSection": "ZIRKEL",
      "supersetN": "Supersatz {{n}}",
      "circuitN": "Zirkel {{n}}",
      "newSuperset": "+ Neuer Supersatz",
      "newCircuit": "+ Neuer Zirkel",
      "groupCta": "+ Supersatz"
    },
    "webview": {
      "close": "Schließen",
      "openExternal": "Im Browser öffnen",
      "errorTitle": "Die Seite konnte nicht geladen werden",
      "errorBody": "Tippe unten, um den System-Browser zu probieren.",
      "fallbackErrorTitle": "Browser konnte nicht geöffnet werden",
      "fallbackErrorBody": "Versuche es aus einem anderen Netzwerk."
    },
    "plates": {
      "title": "Scheibenrechner",
      "close": "Schließen",
      "apply": "Übernehmen",
      "targetLabel": "Ziel",
      "barLabel": "Stange",
      "perSide": "Pro Seite: {{kg}} kg",
      "barOnly": "Nur Stange — keine Scheiben nötig.",
      "pairs_one": "{{count}} Paar",
      "pairs_other": "{{count}} Paare",
      "plates_one": "{{count}} Scheibe",
      "plates_other": "{{count}} Scheiben",
      "loadedEnd": "Beladenes Ende: {{kg}} kg",
      "landmineHint": "Landmine: nur das freie Ende wird beladen, das andere ist im Bodenpivot fixiert.",
      "remainder": "Abweichung {{kg}} kg — der Bestand passt nicht genau.",
      "belowBar": "Ziel unterhalb des Stangengewichts.",
      "invalid": "Gib ein gültiges Gewicht ein.",
      "inventoryShow": "Hantelscheiben-Bestand bearbeiten",
      "inventoryHide": "Hantelscheiben-Bestand ausblenden",
      "inventoryTitle": "Verfügbare Paare",
      "pairsIncrement": "Paar hinzufügen",
      "pairsDecrement": "Paar entfernen",
      "signLabel": "EXTRA-VORZEICHEN",
      "signAdd": "+ Mit Zusatzgewicht",
      "signAssist": "− Unterstützt"
    },
    "restTimerScreen": {
      "title": "Timer",
      "back": "Zurück"
    },
    "licenses": {
      "title": "Open-Source-Lizenzen",
      "back": "Zurück",
      "headlineIntro": "JackedLogs stützt sich auf eine kleine Gruppe von Bibliotheken, die das App-Erlebnis wesentlich prägen. Tippe eine Zeile an, um das Projekt zu öffnen — und erwäge, jene zu unterstützen, die du am häufigsten nutzt.",
      "coreSection": "Kernbibliotheken ({{count}})",
      "viewAllTitle": "Alle Pakete anzeigen",
      "viewAllSub": "Vollständige Namensnennung für die {{count}} im APK enthaltenen Pakete, nach Projekt gruppiert.",
      "allTitle": "Alle Pakete ({{count}})",
      "searchAll": "Name, Gruppe, Lizenz oder Autor suchen",
      "groupOther": "Sonstige Pakete",
      "empty": "Kein Paket entspricht der Suche.",
      "footer": "Erstellt am {{date}}",
      "openErrorTitle": "Link kann nicht geöffnet werden"
    },
    "share": {
      "newPR": "NEUER PR",
      "topLifts": "TOP ÜBUNGEN",
      "durationMinute": "Min.",
      "durationHour": "Std.",
      "durationMinuteShort": "m",
      "footerSets": "Sätze",
      "footerDensitySuffix": "/Min.",
      "fallbackLabel": "Gesamtvolumen",
      "timeLabel": "Gesamtzeit",
      "tutLabel": "TUT",
      "impulseUnit": "kg·s",
      "impulseLabel": "Impuls",
      "e1rmSuffix": "E1RM"
    },
    "postSession": {
      "blockCalories": "Kalorien",
      "blockEffort": "Anstrengung",
      "effortHr": "{{avg}} Ø · {{peak}} max bpm",
      "effortHrMax": "{{pct}}% HFmax",
      "shareTitle": "JackedLogs Trainingseinheit",
      "shareErrorTitle": "Teilen fehlgeschlagen",
      "headlineLabelPR": "NEUER E1RM",
      "headlineLabelDelta": "GROSSER SPRUNG +{{delta}}",
      "headlineLabelSolid": "SOLIDE EINHEIT",
      "headlineSolidValue": "{{volume}} in {{duration}}",
      "headlineFallback": "{{label}} — {{sets}} Sätze",
      "blockTopLifts": "Top-Übungen",
      "fromSet": "aus {{weight}} × {{reps}}",
      "blockVolume": "Volumen",
      "blockDuration": "Dauer",
      "blockDensity": "Dichte",
      "barsTitle": "Belastung pro Muskel",
      "bodyTitle": "Beanspruchte Muskeln",
      "sharing": "Wird vorbereitet…",
      "shareCta": "Trainingskarte teilen",
      "done": "Fertig",
      "summaryTitle": "Training gespeichert"
    },
    "common": {
      "back": "Zurück",
      "save": "Speichern",
      "cancel": "Abbrechen",
      "close": "Schließen"
    },
    "account": {
      "title": "Konto",
      "navSub": "Name, Passwort, Export, Löschen, Abmelden",
      "nameLabel": "NAME",
      "namePlaceholder": "Dein Name",
      "saved": "Gespeichert",
      "passwordLabel": "PASSWORT ÄNDERN",
      "currentPassword": "Aktuelles Passwort",
      "newPassword": "Neues Passwort",
      "confirmPassword": "Neues Passwort bestätigen",
      "passwordChanged": "Passwort geändert.",
      "passwordSubmit": "Passwort aktualisieren",
      "deleteNeedsConnection": "Zum Löschen des Kontos ist eine Verbindung nötig. Stelle die Verbindung wieder her und versuche es erneut — diese Anfrage wird nie für später gespeichert."
    },
    "prefs": {
      "title": "Einheiten & Anzeige",
      "navSub": "Einheiten, Sprache, Hinweise",
      "unitsLabel": "Einheiten",
      "unitsHelp": "Standard-Gewichtseinheit für neue Sätze. Du kannst sie im Logger weiterhin pro Zeile überschreiben.",
      "weekStartLabel": "Woche beginnt am",
      "weekStartHelp": "Der Tag, an dem deine Trainingswoche neu startet. Die wöchentlichen Muskelziele zählen ab diesem Tag.",
      "unitsKg": "Kilogramm (kg)",
      "unitsLb": "Pfund (lb)",
      "glucoseUnitsLabel": "Glukose-Einheiten",
      "glucoseUnitsHelp": "Wie Glukose angezeigt und eingegeben wird. So oder so gleich gespeichert.",
      "glucoseMmol": "mmol/L",
      "glucoseMgdl": "mg/dL",
      "themePaletteLabel": "Themenpalette",
      "themePaletteHelp": "Wähle die app-weite Farbpalette.",
      "themeModeLabel": "Erscheinungsbild",
      "themeModeHelp": "Der Systemeinstellung folgen oder hell bzw. dunkel erzwingen.",
      "themeMode": {
        "system": "System",
        "light": "Hell",
        "dark": "Dunkel"
      }
    },
    "timeline": {
      "setNumber": "Satz {{n}}",
      "fail": "Fehlversuch",
      "failTip": "Fehlversuch speichert den Satz als versucht, aber nicht geschafft. Er zählt trotzdem als erledigt (der Pausentimer startet), zeigt ✕ in der Timeline und fließt nicht in dein e1RM ein.",
      "failTipA11y": "Was bedeutet Fehlversuch?",
      "e1rmValue": "e1RM {{value}}",
      "e1rmPctOfBest": "{{pct}}% vom Best",
      "e1rmNewBest": "Best",
      "e1rmLegend": "e1RM",
      "setVolume": "Σ {{value}} {{unit}}",
      "myorepTag": "Myo-Reps",
      "dropsetTag": "Drop",
      "myorepA11y": "Myo-Reps-Satz",
      "dropsetA11y": "Drop-Satz",
      "setVolumeA11y": "Satzvolumen {{value}} {{unit}}",
      "setSummaryBothSidesA11y": "{{reps}} Wiederholungen mit {{weight}} {{unit}} pro Seite, beide Seiten gezählt",
      "e1rmLegendA11y": "Was ist e1RM?",
      "e1rmTip": "e1RM ist dein geschätztes 1RM für den Satz (Epley, Wdh. ≤ 12). „% vom Best“ vergleicht ihn mit deinem besten e1RM der letzten Zeit — niedriger = Luft nach oben; ↑ Best = neuer geschätzter Rekord.",
      "durationLabel": "Dauer",
      "hourShort": "Std",
      "minShort": "Min",
      "secShort": "Sek",
      "started": "Einheit gestartet",
      "addSet": "Satz hinzufügen",
      "removeSet": "Satz entfernen",
      "prevSet": "Vorheriger Satz",
      "nextSet": "Nächster Satz",
      "allLogged": "Alle Sätze erfasst — tippe + für einen weiteren.",
      "rosterLabel": "Übungen",
      "rosterHint": "tippen zum Wechseln",
      "focusEmptyHasRoster": "Wähle oben eine Übung aus, um zu beginnen, oder füge eine neue hinzu.",
      "focusAllLogged": "Alle Sätze erfasst — füge eine Übung hinzu oder speichere unten.",
      "cueNextSet": "→ Satz {{n}}/{{total}}",
      "cueNextExercise": "→ {{name}}",
      "rosterExpandA11y": "Übungsliste ausklappen",
      "rosterCollapseA11y": "Übungsliste einklappen",
      "rosterState": {
        "done": "fertig",
        "inProgress": "läuft",
        "notDone": "offen"
      },
      "rosterOccurrenceA11y": "{{label}} ({{index}} von {{count}})",
      "exerciseNote": "Übungsnotiz",
      "notePlaceholder": "Notiz zur Timeline hinzufügen…",
      "noteSend": "Notiz senden",
      "noteExpandA11y": "Notiz — zum vollständigen Lesen tippen",
      "noteDeleteA11y": "Notiz löschen",
      "dropsetActive": "Dropset — Runden unten bearbeiten.",
      "editingLogged": "Erfasster Satz {{n}} wird bearbeitet — Änderungen werden mit der Einheit gespeichert.",
      "addSetLocked": "Bearbeitung einer vergangenen Einheit: Sätze können nicht hinzugefügt werden. Korrigiere die Werte oder entferne einen Satz.",
      "createGroupLocked": "Bearbeitung einer vergangenen Einheit: Ein Superset kann nicht erstellt werden.",
      "splitGroupLocked": "Bearbeitung einer vergangenen Einheit: Ein Superset kann nicht aufgelöst werden.",
      "setTypeLocked": "Bearbeitung einer vergangenen Einheit: Der Satztyp (Dropset/Myorep) kann nicht geändert werden.",
      "addStepLocked": "Bearbeitung einer vergangenen Einheit: Es kann kein Dropset-Schritt hinzugefügt werden.",
      "setState": {
        "pending": "Satz {{n}} von {{total}}, offen",
        "done": "Satz {{n}} von {{total}}, erledigt",
        "pr": "Satz {{n}} von {{total}}, persönlicher Rekord",
        "failed": "Satz {{n}} von {{total}}, Fehlversuch"
      },
      "holdLabel": "Halten"
    },
    "home": {
      "targetsTopPatterns": "Top-Muster",
      "targetsSummary": "{{on}} von {{total}} im Ziel",
      "targetsHint": "Hefte ein Programm mit Wochenzielen an, um diese zu bewerten.",
      "targetsZoneOnTarget": "im Ziel",
      "targetsZoneOver": "über",
      "targetsZoneUnder": "im Aufbau",
      "targetsNoCoverage": "nicht abgedeckt",
      "targetsPrescribed": "Plan {{n}}",
      "targetsEmptyTitle": "Noch keine Ziele",
      "targetsEmptySub": "Lege fest, wie viel du jeden Muskel pro Woche trainieren willst. Dein Plan arbeitet darauf hin; die Home-Anzeige zeigt dir, wo du stehst.",
      "targetsEmptyCta": "Ziele festlegen",
      "weekEyebrow": "Diese Woche",
      "weeklyTitle": "Letzte 7 Tage",
      "weeklySessions": "Workouts",
      "weeklyVolume": "Volumen",
      "weeklyA11y": "{{sessions}} Workouts, {{volume}} Volumen",
      "viewProgress": "Fortschritt ansehen",
      "badgesTitle": "Badges",
      "newsTitle": "Neuigkeiten",
      "newsEmpty": "App-Neuigkeiten erscheinen hier.",
      "prPrev": "Vorheriger Rekord",
      "prNext": "Nächster Rekord",
      "prPosition": "Rekord {{n}} von {{total}}",
      "eyebrow": "HEUTE",
      "blankTitle": "Bereit zum Training?",
      "blankLoading": "Plan wird geladen…",
      "blankBody": "Derzeit kein aktives Programm. Starte ein leeres Workout, oder nutze ＋, um eins zu planen.",
      "newWorkout": "Neues Training",
      "programMeta": "{{program}} · Woche {{week}}",
      "morePreview": " +{{count}} weitere",
      "startToday": "▶ Einheit starten",
      "blankInstead": "Stattdessen ein leeres Training starten",
      "recentPrValue": "{{weight}} × {{reps}}",
      "recentPrValueBodyweight": "{{reps}} Wdh. KG",
      "prToday": "Heute",
      "prDaysAgo": "vor {{n}} T.",
      "weightTitle": "Körpergewicht",
      "weightSaved": "Gespeichert ✓",
      "weightCurrent": "Zuletzt: {{value}} {{unit}}",
      "weightNone": "Erfasse dein Gewicht, um Trends zu verfolgen.",
      "weightSave": "Speichern",
      "repeatWorkout": "Training wiederholen",
      "form": {
        "title": "Bereitschaft",
        "ready": "Bereit",
        "caution": "Vorsicht",
        "rest": "Ruhe",
        "reasonNoData": "Zeichne eine Einheit auf, um deine Bereitschaft zu verfolgen.",
        "reasonWellRecovered": "Gut erholt seit der letzten Einheit — du kannst Gas geben.",
        "reasonBalanced": "Deine Trainingsbelastung wirkt ausgewogen.",
        "reasonFreshStart": "Du steigst wieder ein — fang ruhig an und bau eine Basis auf.",
        "reasonShortRest": "Einheiten dicht hintereinander — achte auf die Erholung.",
        "reasonHighFrequency": "Eine Woche mit hohem Volumen — erwäge einen leichteren Tag.",
        "reasonLoadSpike": "Deine Belastung ist stark über deinen jüngsten Durchschnitt gestiegen.",
        "reasonLongGap": "Es ist eine Weile her — fang leicht an, um wieder hochzukommen."
      },
      "glucoseSave": "Speichern",
      "weightSaveA11y": "Körpergewicht speichern",
      "glucoseSaveA11y": "Glukosewert speichern"
    },
    "superset": {
      "startingWith": "Supersatz beginnen mit",
      "joinExisting": "Zu bestehendem",
      "pairInWorkout": "Kombinieren (in diesem Training)",
      "templates": "Gespeicherte Supersätze",
      "templateInsertHint": "Diesen Supersatz einfügen; lange drücken zum Löschen",
      "templateDeleteBody": "Diesen gespeicherten Supersatz entfernen?",
      "createCta": "Supersatz erstellen ({{n}})",
      "cueCycle": "{{group}}, Übung {{pos}} von {{total}}. Tippen, um zu {{next}} zu wechseln.",
      "cueStatic": "{{group}}, Übung {{pos}} von {{total}}",
      "menuOpen": "Supersatz-Optionen",
      "menuSaveTemplate": "Als Vorlage speichern",
      "menuAddExercise": "Übung hinzufügen",
      "menuMoveUp": "Nach oben",
      "menuMoveDown": "Nach unten",
      "menuRemoveMember": "Diese Übung entfernen",
      "menuSplit": "Supersatz auflösen",
      "namePlaceholder": "Supersatz-Name (optional)"
    }
  },
  "settings": {
    "restDefaults": {
      "title": "Pausen-Standardwerte",
      "globalLabel": "Globaler Standard",
      "globalUnset": "Nicht festgelegt — verwende {{n}}s",
      "customLabel": "Übungen mit individuellem Standard",
      "customEmpty": "Keine übungsspezifischen Werte. Öffne im Logger die Pausen-Anzeige und tippe ⚙, um einen festzulegen.",
      "customRemoveA11y": "Individuelle Pause für {{name}} entfernen",
      "clearGlobal": "Zurücksetzen"
    },
    "hints": {
      "title": "Hinweise",
      "label": "Hinweis-Tooltips anzeigen",
      "help": "Tippe auf eine Spaltenüberschrift, um ihre Bedeutung zu sehen. Ausschalten, um die Hinweise zu verbergen."
    },
    "effortNudge": {
      "label": "Anstrengungs-Erinnerung",
      "help": "Ein seltener, dezenter Impuls auf der Anstrengungsleiste, solange ein Satz auf das Loggen wartet."
    },
    "inWorkoutMeter": {
      "label": "Ziel-Meter im Workout",
      "help": "Ein Streifen oben auf der Übungskarte mit dem Wochenziel für die Muskeln, die du trainierst."
    },
    "audio": {
      "title": "Audio",
      "soundLabel": "Timer-Ton",
      "soundHelp": "Wird abgespielt, wenn die Pause vorbei ist.",
      "vibrationLabel": "Vibration",
      "vibrationHelp": "Vibriert, wenn die Pause vorbei ist.",
      "previewButton": "Anhören",
      "pickerTitle": "Ton wählen",
      "pickerCancel": "Abbrechen",
      "category": {
        "serious": "Standard",
        "fun": "Lustig"
      },
      "soundOptions": {
        "none": "Keiner",
        "chime_crisp": "Glöckchen",
        "ding_dong": "Ding-dong",
        "meditation_bell": "Klangschale",
        "tada_fanfare": "Tadaa",
        "cartoon_boing": "Boing",
        "ah_yeah": "Yeah!"
      }
    },
    "timerDefaults": {
      "range": "{{min}}–{{max}} s eingeben",
      "globalTitle": "Globale Standards",
      "restGlobal": "Pausen-Timer",
      "holdGlobal": "Halte-Timer",
      "customLabel": "Werte pro Übung",
      "customEmpty": "Noch keine Werte pro Übung. Auf + Hinzufügen tippen.",
      "unset": "Nicht gesetzt — {{n}}s",
      "add": "+ Hinzufügen",
      "editRestA11y": "Pause für {{name}} bearbeiten",
      "editHoldA11y": "Halten für {{name}} bearbeiten",
      "editA11y": "Timer für {{name}} bearbeiten",
      "isDefault": "Standard",
      "equalsDefaultHint": "Ein Wert gleich dem globalen Standard wird nicht als Override gespeichert.",
      "remove": "Entfernen"
    },
    "backend": {
      "section": "Backend",
      "title": "Backend",
      "navSub": "Wähle, wohin dieser Build schreibt",
      "pickLabel": "Meine Daten schreiben nach",
      "pickHelp": "Nur Dev-Build. Jedes Backend hält eigene Sitzung, eigene Warteschlangen und einen eigenen Trainingsentwurf — ein Wechsel rührt das andere nie an.",
      "stageProduction": "PRODUKTION",
      "stageLab": "LABOR",
      "liveLabel": "DU SCHREIBST NACH",
      "liveChecking": "Prüfung…",
      "liveUnknown": "Unbekannt — das Backend hat nicht geantwortet",
      "liveNotProduction": "Hier liegt nicht dein echtes Training.",
      "confirmTitle": "Backend wechseln?",
      "confirmBody": "Die App lädt gegen {{stage}} neu. Dort ist eventuell eine neue Anmeldung nötig, und zwischengespeicherte Listen werden verworfen.",
      "confirmCta": "Wechseln",
      "blockedByQueue": "Nicht gewechselt: einige Schreibvorgänge sind noch nicht raus. Geh wieder online und lass die Warteschlangen leerlaufen."
    },
    "animations": {
      "cellularLabel": "Animationen auch ohne WLAN laden",
      "cellularHelp": "Standardmäßig aus. Die Animationen sind ohnehin da: das hier erlaubt der App nur, sie über mobile Daten im Voraus zu holen, etwa 20 bis 30 MB für ein Programm."
    }
  },
  "web": {
    "crash": {
      "body": "Die App ist auf einen unerwarteten Fehler gestoßen. Deine gespeicherten Daten sind sicher — lade neu, um fortzufahren.",
      "reload": "Neu laden"
    },
    "postSession": {
      "headlineLabelPR": "NEUER E1RM",
      "headlineLabelDelta": "GROSSER SPRUNG +{{delta}}",
      "headlineLabelSolid": "SOLIDE EINHEIT",
      "headlineSolidValue": "{{volume}} in {{duration}}",
      "headlineFallback": "{{label}} — {{sets}} Sätze",
      "blockE1rm": "E1RM",
      "fromSet": "aus {{weight}} × {{reps}}",
      "blockVolume": "Volumen",
      "blockDuration": "Dauer",
      "blockDensity": "Dichte",
      "barsTitle": "Belastung pro Muskel",
      "bodyTitle": "Beanspruchte Muskeln",
      "sharing": "Wird vorbereitet…",
      "shareCta": "Trainingskarte teilen"
    }
  },
  "muscle": {
    "quadriceps": "Quadrizeps",
    "hamstrings": "Hintere Oberschenkel",
    "glutes": "Gesäßmuskeln",
    "adductors": "Adduktoren",
    "abductors": "Abduktoren",
    "calves": "Waden",
    "core": "Rumpf",
    "obliques": "Schräge Bauchmuskeln",
    "erectors": "Unterer Rücken",
    "pectoralis": "Brust",
    "anterior-delts": "Vorderer Deltamuskel",
    "lateral-delts": "Seitlicher Deltamuskel",
    "triceps": "Trizeps",
    "lats": "Latissimus",
    "rhomboids": "Rautenmuskeln",
    "rear-delts": "Hinterer Deltamuskel",
    "traps": "Trapezmuskel",
    "biceps": "Bizeps",
    "forearms": "Unterarme"
  },
  "experience": {
    "menuLabel": "Aktives Profil",
    "athlete": "Athlet",
    "coach": "Coach",
    "admin": "Admin"
  },
  "composer": {
    "targetAxisExercise": "Übung",
    "targetKeyExercise": "Übung",
    "targetRefAvg": "~{{n}}/Wo. Ø",
    "targetRefLast": "letzte Wo. {{n}}",
    "targetRefNone": "Keine Daten in den letzten 4 Wochen",
    "targetRefProgram": "Programm gibt ~{{n}}/Wo. vor",
    "targetUseAvg": "Durchschnitt nehmen",
    "targetUseProgram": "Programmwert nehmen",
    "projectionTitle": "Zielverteilung",
    "projectionWeek": "Woche {{n}}",
    "projectionContext": "Vom Programm in Woche {{n}} vorgeschriebene Sätze / Last.",
    "projectionTarget": "Ziel",
    "projectionWeekTotal": "Woche",
    "projectionRamp": "Zyklus",
    "projectionWeekShort": "W{{n}}",
    "projectionEmpty": "Nicht geplant",
    "targetsTitle": "Wochenziele",
    "targetsEmptyTitle": "Keine Wochenziele",
    "targetsEmptySub": "Füge eines hinzu, um die Level-Anzeige zu aktivieren.",
    "targetAdd": "Ziel hinzufügen",
    "targetRemove": "Ziel {{name}} entfernen",
    "targetCollapse": "Einklappen",
    "targetAxis": "Achse",
    "targetAxisMuscle": "Muskel",
    "targetMetric": "Metrik",
    "targetMetricHardSets": "Harte Sätze",
    "targetMetricTonnage": "Tonnage",
    "targetMetricReps": "Wdh.",
    "prescriptionEyebrow": "Vorgabe",
    "prescriptionSub": "Was dieser Block pro Woche vorgibt, gemessen an deinen Zielen.",
    "targetKeyMuscle": "Muskel",
    "targetValue": "Wochenziel",
    "targetUnitHardSets": "harte Sätze",
    "targetUnitTonnage": "kg",
    "targetUnitReps": "Wdh.",
    "targetBand": "±{{pct}} %",
    "targetNotScored": "noch nicht in der Anzeige",
    "targetNotScoredNote": "Dieser Zieltyp zählt noch nicht in der Level-Anzeige.",
    "targetBandLabel": "Toleranz",
    "targetBandAsym": "−{{lo}} % / +{{hi}} %",
    "targetBandBelow": "Prozent unter dem Ziel",
    "targetBandAbove": "Prozent über dem Ziel",
    "targetBandRange": "Unten 0–99 %, oben 0 % oder mehr.",
    "compose": "Zusammenstellen",
    "preview": "Vorschau",
    "addExercises": "Übungen hinzufügen",
    "editingBlockDay": "Bearbeitung von T{{d}} — Aktualisieren wirkt auf diesen Tag (weitere Tage antippen, um sie dort ebenfalls anzuwenden)",
    "editingRampDay": "Wochen-Ramp an T{{d}} — Aktualisieren wirkt auf die gewählten Wochen, nur dieser Tag",
    "segments": "Segmente",
    "rampSwitchHint": "Erst aktualisieren oder abbrechen, dann das Segment wechseln",
    "setupHint": "Lege die Startform fest — Tage kannst du später im Editor hinzufügen oder entfernen und die Wochen ändern.",
    "repsHint": "Reps „5+“ = AMRAP: mindestens 5, dann so viele wie möglich.",
    "repsHintA11y": "Wie Wiederholungen geschrieben werden",
    "addingWeek": "Neue Woche W{{n}} — Aktualisieren fügt sie dieser Übung hinzu",
    "cloneWeek": "Woche klonen…",
    "cloneWeekFrom": "Von",
    "cloneWeekApply": "Klonen",
    "cloneWeekConflict": "{{name}} hat in W{{week}} (D{{day}}) bereits Inhalt",
    "cloneWeekEmpty": "Nichts zu klonen — gefüllte Quellwoche und mindestens ein Ziel wählen",
    "cloneDayEmpty": "An diesem Tag gibt es nichts zu klonen",
    "editingWeekDay": "Nur W{{n}} an T{{d}} wird bearbeitet — Aktualisieren löst sie aus dem Segment",
    "perWeek": "Pro Woche",
    "dupExercise": "{{name}} ist in D{{day}} in den gewählten Wochen bereits vorhanden",
    "cloneDay": "D{{n}} klonen nach…",
    "cloneDayTarget": "Nach",
    "days": "Tage",
    "weeks": "Wochen",
    "setNote": "Satz-Notiz",
    "removeExercise": "Übung entfernen",
    "replaceExercise": "Übung ersetzen",
    "clone": "Klonen",
    "remove": "Entfernen",
    "removeConfirm": "Bestätigen? ({{n}} Zellen)",
    "verbatim": "Erweiterter Slot (Multi-Variante) — bleibt unverändert, hier nicht bearbeitbar",
    "metaWeeks": "{{n}} Wochen",
    "metaDays": "{{n}} Trainingstage",
    "gridToggle": "Intensitätsraster",
    "addDay": "Tag hinzufügen",
    "removeDay": "Tag D{{n}} entfernen",
    "removeDayConfirm": "Bestätigen — Tag D{{n}} entfernen?",
    "dayEmpty": "Noch keine Übungen an diesem Tag. Füge eine hinzu, um ihn aufzubauen.",
    "checkEmptyCell": "W{{w}}·D{{d}} hat keine Übungen",
    "checkPctNoMax": "{{name}} nutzt %MAX ohne gespeichertes MAX",
    "exerciseNote": "Notiz zur Übung",
    "exerciseNotePlaceholder": "Notiz zu dieser Übung (beim Loggen sichtbar)",
    "panelHint": "Übung antippen zum Bearbeiten, Klonen oder Entfernen",
    "warnLine_one": "{{count}} Hinweis",
    "warnLine_other": "{{count}} Hinweise",
    "adjacencyWarnLine_one": "{{count}} Hinweis zur Muskelerholung",
    "adjacencyWarnLine_other": "{{count}} Hinweise zur Muskelerholung",
    "adjacencyWarnItem": "{{muscle}} an aufeinanderfolgenden Tagen trainiert ({{count}}×)",
    "publishChecklist": "Offene Hinweise (Veröffentlichen ist trotzdem möglich)",
    "publishClean": "Keine offenen Hinweise.",
    "weekShort": "Woche",
    "placed": "aktiv",
    "notPlaced": "inaktiv",
    "placementHint": "Eine Zelle gedrückt halten, um sie hier zu setzen oder zu entfernen.",
    "addWeek": "Woche hinzufügen",
    "removeWeek": "Woche entfernen",
    "removeWeekConfirm": "Bestätigen — diese Woche und ihre Sätze entfernen"
  },
  "gym": {
    "setPlace": "Wo?",
    "whichPlace": "Wo trainierst du?",
    "newPlace": "Ort hinzufügen",
    "fallback": "Standard",
    "chipA11y": "Trainingsort",
    "footnote": "Sortiert, was du zuerst siehst. Geht nie an einen Coach.",
    "namePlaceTitle": "Diesen Ort benennen",
    "namePlaceHint": "Name des Ortes",
    "namePlaceSave": "Diesen Ort verwenden",
    "pinPlace": "{{place}} als Standard-Ort festlegen",
    "unpinPlace": "{{place}} als Standard-Ort entfernen",
    "pinHint": "Merkt sich diesen als den Ort, an dem du meistens trainierst.",
    "unpinHint": "Vergisst deinen Standard-Ort.",
    "pinErrorTitle": "Nicht gespeichert",
    "pinErrorBody": "Dein Standard-Ort bleibt unverändert."
  }
}
